/* Language pack: ar */
export const translationsAr = {
	resumeRecording: "استئناف",
	chatCallMissed: "فائتة",
	chatCallDeclined: "مرفوضة",
	chatAudioConference: "مؤتمر صوتي",
	chatVideoConference: "مؤتمر فيديو",

	IDCardImages: "صور بطاقة الهوية",
	IT: "تكنولوجيا المعلومات",
	Status: "الحالة",
	abbreviation: "اختصار",
	aboutUsItems: "عناصر من نحن",
	absent: "غائب",
	accept: "قبول",
	actSendingDate: 'تاريخ إرسال "العمل"',
	actionTimestamp: "طابع زمني للإجراء",
	actionType: "نوع الإجراء",
	actions: "الإجراءات",
	activateStep7_8_9: "تعيين إلى قسم خطوط نقل الطاقة ( 7, 8, 9 )",
	activateStep8: "تعيين إلى قسم الجيوديسيا ( 8 )",
	activatedProjects: "المشاريع المفعلة",
	active: "نشط",
	activeCarts: "عربات التسوق النشطة",
	activeClients: "العملاء النشطون",
	activeCustomers: "العملاء النشطون",
	activeProjectSteps: "خطوات المشروع النشطة",
	activePromos: "العروض الترويجية النشطة",
	activeSales: "المبيعات النشطة",
	activeSalesEvents: "أحداث المبيعات النشطة",
	activeServices: "الخدمات النشطة",
	activeSteps: "خطوات نشطة",
	activeStreams: "التدفقات النشطة",
	activeTasks: "المهام النشطة",
	activeTime: "وقت نشط",
	activity: "النشاط",
	actualHours: "الوقت الفعلي",
	adInterval: "فاصل الإعلان",
	adIntervalOverride: "قواعد التخطيط",
	adIntervalOverrideDesc: "قواعد التخطيط",
	adIntervalOverrideValue: "قواعد التخطيط",
	adPlaylist: "قائمة تشغيل الإعلانات",
	adPlaylists: "قوائم تشغيل الإعلانات",
	adTracks: "مسارات الإعلانات",
	add: "إضافة",
	addAttendance: "إضافة حضور",
	addFeature: "إضافة خاصية",
	addFeatureLine: "إضافة سطر خاصية",
	addFiles: "أضف المزيد من الملفات",
	addMoreFiles: "إضافة ملفات إضافية",
	addNew: "إضافة جديدة",
	addPriceLine: "إضافة سطر سعر",
	addRule: "إضافة قاعدة",
	addToList: "أضف إلى القائمة",
	addVacationInterval: "إضافة فترة الإجازة",
	added: "تم الإضافة",
	additionalDetails: "تفاصيل إضافية",
	address: "عنوان",
	addressData: "بيانات العنوان",
	advanceDeductions: "خصومات السُلفة",
	advertisement: "إعلان",
	age: "عمر",
	ageGroups: "مجموعات عمرية",
	ago: "منذ",
	agreedProjects: "المشاريع المتفق عليها",
	agreementAquipment: "اتفاق على المعدات",
	aiConversations: "المحادثات",
	album: "ألبوم",
	allArtists: "جميع الفنانين",
	allAudioTracks: "جميع المسارات الصوتية",
	allContentItems: "جميع عناصر المحتوى",
	allFilesDeleted: "تم حذف جميع الملفات بشكل دائم",
	allFilesWillBeDeleted: "سيتم حذف جميع الملفات نهائيًا",
	allPlaylists: "جميع قوائم التشغيل",
	allRegisteredContacts: "جميع العملاء المسجلين",
	allTickets: "كل التذاكر",
	amount: "المبلغ",
	analytics: "التحليلات",
	answer: "إجابة",
	apartment: "شقة",
	apply: "تطبيق",
	appsMenu: "قائمة التطبيقات",
	approved: "معتمد",
	approvedInterval: "فترة معتمدة",
	archive: "أرشيف",
	archived: "مؤرشف",
	areYouSure: "هل أنت متأكد؟",
	areYouSureToDelete: "هل أنت متأكد أنك تريد حذف هذا؟",
	artist: "فنان",
	artistObject: "الكائن الفني",
	assignedTo: "معين",
	assignedToUser: "مُعين لـ",
	assignmentToTheConstructionDepartment: "تعيين إلى قسم البناء",
	attach: "إرفاق",
	attachFile: "إرفاق ملف",
	attachments: "المرفقات",
	attendance: "الحضور",
	attendanceFlag: "حالة الحضور",
	attendanceRequiringAttention: "الموظفون الذين يحتاجون إلى انتباه",
	attendanceNoAttentionItems: "لا يوجد موظفون يحتاجون إلى انتباه",
	attendanceMissingCheckIn: "تسجيل دخول مفقود",
	attendanceMissingCheckOut: "تسجيل خروج مفقود",
	attendanceEarlyLeave: "مغادرة مبكرة",
	attendanceEarlyMissings: "مغادرات مبكرة",
	attendanceEarlyMissingHours: "ساعات المغادرة المبكرة",
	attendanceLateHours: "ساعات التأخير",
	attendanceShowWorkedHours: "عرض ساعات العمل",
	attendanceUnapprovedAbsence: "غياب غير معتمد",
	attendanceDeptAttendance: "الحضور حسب القسم",
	attendanceDeviceHealth: "حالة الأجهزة والمزامنة المباشرة",
	attendanceLastSync: "آخر مزامنة",
	attendanceLiveFeed: "بث الحضور المباشر",
	attendanceNoRecentPunches: "لا توجد بصمات حديثة",
	attendanceManualEntryTag: "يدوي",
	attendanceUnmappedPunch: "غير مطابق",
	attendancePendingItems: "قيد الانتظار",
	flexCardTotal: "بطاقات Flex",
	attendanceCards: "بطاقات الحضور",
	flexCardTotalSubtitle: "معرفات Flex المعينة أو المتجاهلة",
	flexCardsAttached: "مرتبطة",
	flexCardsAttachedSubtitle: "معرفات فريدة مرتبطة بالمستخدمين",
	flexCardsIgnored: "متجاهلة",
	flexCardsIgnoredSubtitle: "متجاهلة في إعدادات الموارد البشرية",
	flexCardsDuplicateAttached: "مرتبطة بشكل مكرر",
	flexCardIds: "معرفات البطاقات",
	noDuplicateFlexCards: "لا توجد تكرارات",
	attendanceTrendPctOfEmployeesPresent: "% من الموظفين الحاضرين",
	yesterday: "أمس",
	attendanceFilterThisWeek: "هذا الأسبوع",
	attendanceFilterThisMonth: "هذا الشهر",
	attendanceFilterCustom: "مخصص",
	attendanceSelectRange: "اختر النطاق",
	attendanceCustomRangeCapped: "النطاق المخصص محدود بـ 90 يومًا",
	attendanceLiveBadge: "LIVE",
	attendanceTitleToday: "حضور اليوم",
	attendanceTitleYesterday: "حضور الأمس",
	attendanceTitleThisWeek: "حضور هذا الأسبوع",
	attendanceTitleThisMonth: "حضور هذا الشهر",
	attendanceTitleCustom: "حضور الفترة المحددة",
	attendanceTitleTodayKpis: "مؤشرات حضور اليوم",
	attendanceTitleYesterdayKpis: "مؤشرات حضور الأمس",
	attendanceTitleThisWeekKpis: "مؤشرات حضور هذا الأسبوع",
	attendanceTitleThisMonthKpis: "مؤشرات حضور هذا الشهر",
	attendanceTitleCustomKpis: "مؤشرات الفترة المحددة",
	attendanceTrendDays: "اتجاه الحضور — آخر {n} أيام",
	attendanceNotAttendedYet: "لم يحضر بعد",
	attendanceUpcomingAbsences: "الغيابات القادمة",
	attendanceUpcomingAbsencesEmpty: "لا توجد غيابات قادمة",
	attendanceUpcomingAbsencesTomorrow: "غدًا",
	attendanceUpcomingAbsencesInDays: "خلال {days} أيام",
	attendanceExceptions: "استثناءات الحضور",
	attendanceExceptionsMissingCheckIn: "تسجيلات دخول مفقودة",
	attendanceExceptionsMissingCheckOut: "تسجيلات خروج مفقودة",
	attendanceExceptionsEarlyLeaves: "مغادرات مبكرة",
	attendanceExceptionsUnapprovedAbsences: "غيابات غير معتمدة",
	attendanceExceptionsDuplicatePunches: "بصمات مكررة",
	attendanceMonthlyKpis: "مؤشرات الحضور الشهرية",
	attendanceKpiRate: "معدل الحضور",
	attendanceKpiAvgArrival: "متوسط وقت الوصول",
	attendanceKpiLateArrivals: "حالات التأخير",
	attendanceKpiAbsentDays: "أيام الغياب",
	attendanceKpiOvertimeHours: "ساعات العمل الإضافي",
	attendanceLeaveBalanceOverview: "نظرة عامة على رصيد الإجازات",
	attendanceLeaveBalanceVacationRemaining: "رصيد الإجازة المتبقي",
	attendanceLeaveBalanceSickUsed: "الإجازة المرضية المستخدمة",
	attendanceLeaveBalanceBusinessTrips: "رحلات العمل",
	attendanceLeaveBalancePendingRequests: "الطلبات المعلقة",
	attendanceLeaveBalanceCoverage: "{covered} من أصل {total} موظف",
	attendanceTopInsights: "أبرز رؤى الحضور",
	attendanceInsightNoData: "لا توجد بيانات كافية بعد",
	attendanceInsightHighestLateness: "لدى {dept} أعلى نسبة تأخير هذا الأسبوع ({delta})",
	attendanceInsightFullAttendanceToday: "حقق {dept} حضورًا بنسبة 100%",
	attendanceInsightTrendImproved: "تحسّن الحضور بنسبة {pct}% مقارنة بالفترة السابقة",
	attendanceInsightTrendDeclined: "انخفض الحضور بنسبة {pct}% مقارنة بالفترة السابقة",
	attendanceInsightApproachingOvertime: "يقترب {count} موظفين من حد العمل الإضافي",
	attendancePreviousWeek: "الأسبوع الماضي",
	attendanceCurrentWeek: "هذا الأسبوع",
	attendanceAddInterval: "إضافة فترة",
	attendanceBreakLabel: "استراحة",
	attendanceCorrectionMode: "وضع التصحيح",
	attendanceCustomIntervals: "فترات مخصصة",
	attendanceDashboard: "لوحة الحضور",
	attendanceReports: "التقارير",
	attendanceCalendarTab: "التقويم",
	reports: "التقارير",
	shiftCoverage: "تغطية الورديات",
	previousPeriod: "الفترة السابقة",
	nextPeriod: "الفترة التالية",
	failedToSave: "تعذر حفظ تعليق العمل الإضافي",
	expandForDailyDetail: "توسيع الصف لعرض التفاصيل اليومية",
	noDataForPeriod: "لا توجد بيانات لهذه الفترة",
	attendanceHistory: "سجل الحضور",
	attendanceDayOffTab: "يوم عطلة",
	attendanceDayType: "نوع اليوم",
	attendanceDetectedIntervals: "الفترات المكتشفة",
	attendanceEditDay: "تعديل اليوم",
	attendanceHrsTotal: "ساعات إجمالية",
	attendanceViewWeek: "الأسبوع",
	attendanceViewMonth: "الشهر",
	attendanceViewDay: "اليوم",
	day: "يوم",
	attendanceOpenFrom: "مفتوح منذ {time}",
	attendanceFromStillActive: "منذ {time} → لا يزال نشطًا",
	attendanceTotalWorked: "إجمالي العمل",
	attendanceMissingUncovered: "مفقود / غير مغطى",
	attendanceNoData: "لا توجد بيانات",
	attendanceNoDataForDay: "لا توجد بيانات حضور لهذا اليوم.",
	attendanceIntervalApprovedOk: "معتمد / موافق",
	attendanceIntervalEachRowInvalid: "يُرجى إدخال وقت بداية ونهاية صالح لكل فترة",
	attendanceIntervalTimesInvalid: "يُرجى إدخال وقت بداية ونهاية صالحين",
	attendanceIntervalsMode: "الفترات",
	attendanceIntervalsReviewHint:
		"راجع الفترات الفعلية للعمل والإجازة والفترات الناقصة. أضف أدناه فترات تصحيح يدوية لتعيينها كموافق عليها أو عمل أو عن بُعد أو إجازة مرضية أو إجازة مدفوعة أو غير مدفوعة أو أخرى.",
	attendanceLogSubtitle: "إدخال الحضور يدويًا — العمل، أيام المرض، الإجازة",
	attendanceLogTitle: "سجل الحضور",
	attendanceManualResolutionIntervals: "فترات تصحيح يدوية",
	attendanceMissingLabel: "مفقود",
	attendanceNoManualIntervalsYet: "لم تُضف فترات يدوية بعد",
	attendanceNoUncovered: "لم يُكتشف فترات غير مغطاة",
	attendanceOptionalNotePlaceholder: "ملاحظة اختيارية…",
	attendancePtoLeaveSection: "إجازة مدفوعة / إجازة",
	attendanceReport: "تقرير الحضور",
	attendanceResolveInterval: "معالجة هذه الفترة",
	attendanceResyncTooltip: "إعادة مزامنة الحضور لهذا الموظف",
	attendanceResyncSuccess: "بدأت إعادة مزامنة الحضور",
	attendanceResyncFailed: "فشلت إعادة مزامنة الحضور",
	attendanceSavedSuccess: "تم حفظ الحضور بنجاح",
	attendanceStatusUpcoming: "قادم",
	attendanceSelectEmployeePrompt: "اختر موظفًا لعرض الحضور",
	attendanceTrend: "اتجاه الحضور",
	attendanceTrendPctPresent: "% الحضور",
	attendanceUncoveredMissing: "غير مغطى / مفقود",
	attendanceUnsavedChanges: "تغييرات غير محفوظة",
	attendanceWholeDayStatus: "حالة اليوم كاملًا",
	shiftWorker: "عامل نوبات",
	attendanceIgnoreMode: "تجاهل",
	attendanceIgnoreScopeWeekdays: "أيام الأسبوع",
	attendanceIgnoreScopeDateRange: "نطاق التاريخ",
	attendanceIgnoreScopeWeekdaysHint: "يُطبَّق فقط على أيام الأسبوع المحددة ضمن هذه الفترة.",
	attendanceIgnoreScopeDateRangeHint: "يُطبَّق على كل يوم ضمن هذه الفترة.",
	attendanceIgnoreAppliesTo: "ينطبق على",
	attendanceIgnoreLateArrival: "التأخر في الحضور",
	attendanceIgnoreEarlyLeave: "المغادرة المبكرة",
	attendanceIgnoreWindowStart: "بداية فترة التجاهل",
	attendanceIgnoreWindowEnd: "نهاية فترة التجاهل",
	attendanceIgnoreRulesList: "قواعد التجاهل",
	attendanceIgnoreRulesEmpty: "لا توجد قواعد تجاهل بعد",
	attendanceIgnoreDaysOfWeekRequired: "اختر يومًا واحدًا على الأقل",
	attendanceIgnoredLabel: "متجاهَل",
	attendanceNoCardLabel: "لا توجد بطاقة",
	attendanceWork: "عمل",
	attendanceWorked: "عمل",
	attendanceWorkedIntervals: "فترات العمل",
	attendanceMissingIntervals: "الفترات المفقودة",
	attendanceStillInOffice: "لا يزال في المكتب",
	attendanceAddEvent: "إضافة حدث",
	attendanceAddAttendanceEvent: "إضافة حدث حضور",
	attendanceDeleteEventTitle: "حذف حدث الحضور؟",
	attendanceDeleteEventText: "سيؤدي هذا إلى إزالة حدث الدخول/الخروج المضاف يدويًا فقط.",
	attendanceNoMissingIntervals: "لا توجد فترات مفقودة لهذا اليوم",
	attendanceOfficeSince: "منذ {time}",
	attendanceLastOutAt: "آخر خروج {time}",
	attendanceEventSingular: "حدث",
	attendanceEventPlural: "أحداث",
	attendancePunchIn: "دخول",
	attendancePunchOut: "خروج",
	solveThis: "حل هذا",
	editSolvedStatus: "تعديل الحالة المحلولة",
	officeStatus: "حالة المكتب",
	outOfOffice: "خارج المكتب",
	noPunches: "لا توجد تسجيلات",
	lastActionWasCheckIn: "آخر إجراء كان تسجيل دخول",
	lastActionWasCheckOut: "آخر إجراء كان تسجيل خروج",
	noCheckInYet: "لا يوجد تسجيل دخول بعد",
	manual: "يدوي",
	resolved: "تم الحل",
	attendanceManualStatusApplyTicketTimeTo: "تطبيق وقت التذكرة على",
	attendanceManualStatusColumnAttendanceType: "نوع الحضور",
	attendanceManualStatusColumnTimeAction: "إجراء الوقت",
	attendanceManualStatusMapsToType: "يُطابق نوع الحضور",
	attendanceManualStatusTicketTimeAction: "إجراء وقت أتمتة التذكرة",
	attendanceTicketTimePhraseAdd: "إضافة وقت {type}",
	attendanceTicketTimePhraseSubtract: "طرح وقت {type}",
	attendanceTimeOpAdd: "إضافة وقت التذكرة",
	attendanceTimeOpNone: "بدون تغيير في رصيد الوقت",
	attendanceTimeOpSubtract: "طرح وقت التذكرة",
	attendanceTypeOptionAbsent: "غائب",
	attendanceTypeOptionBusinessTrip: "رحلة عمل",
	attendanceTypeOptionHolidayNonWorking: "عطلة / يوم غير عمل",
	attendanceTypeOptionJustifiedAbsence: "غياب مبرر (بعذر)",
	attendanceTypeOptionMaternity: "إجازة أمومة",
	attendanceTypeOptionPaidVacation: "إجازة مدفوعة",
	attendanceTypeOptionRemote: "عمل عن بُعد",
	attendanceTypeOptionSickLeave: "إجازة مرضية",
	attendanceTypeOptionUnjustifiedAbsence: "غياب غير مبرر (بدون عذر)",
	attendanceTypeOptionUnpaidLeave: "إجازة بدون أجر",
	attendanceTypeOptionWork: "عمل",
	audio: "صوتي",
	autoDeletion: "الحذف التلقائي",
	averageDailyHours: "متوسط ساعات العمل اليومية",
	avgDaily: "المتوسط اليومي",
	avgDailyHours: "متوسط الساعات اليومية",
	avgHoursPerWorkingDay: "متوسط الساعات لكل يوم عمل",
	avgOrderValue: "متوسط قيمة الطلب",
	avgResolutionTime: "متوسط وقت الحل",
	avgResponseTime: "متوسط وقت الاستجابة",
	avgTracksPerPlaylist: "متوسط المسارات/قائمة التشغيل",
	back: "عودة",
	bank: "بنك",
	bankAccount: "حساب بنكي",
	bankCart: "بطاقة بنكية",
	bankEmitet: "بنك",
	banner: "لافتة",
	baseSalary: "الراتب الأساسي",
	baseSalaryHourlyLinked: "يحدّث الأجر بالساعة من الأساس ÷ الساعات العادية (عندما الساعات > 0).",
	basicInformation: "معلومات أساسية",
	beginningOfAcquaintance: "بداية التعارف",
	beginningOfContract: "بداية العقد",
	beginningOfTraining: "بداية التدريب",
	benefits: "المزايا",
	bestSeller: "الأكثر مبيعًا",
	bestSellers: "الأكثر مبيعاً",
	bestSellingItemsByRevenue: "أفضل العناصر مبيعاً حسب الإيرادات",
	bitrate: "معدل البت",
	biweekly: "كل أسبوعين",
	blogItems: "عناصر المدونة",
	blogs: "المدونات",
	bonuses: "المكافآت",
	bpm: "BPM",
	branch: "فرع الشبكة الكهربائية",
	branches: "قائمة الفروع",
	branchesCitiesVillages: "الفروع، المدن، القرى",
	brand: "العلامة التجارية",
	brands: "العلامات التجارية",
	building: "مبنى",
	businessTrip: "رحلة عمل",
	buttonText: "نص الزر",
	bypassSteps: "تجاوز الخطوات",
	calAddCalendarTooltip: "أنشئ تقويمًا وشاركه مع الفريق",
	calAddEvent: "إضافة حدث",
	calAddReminder: "إضافة تذكير",
	calAlarm15m: "قبل 15 دقيقة",
	calAlarm1d: "قبل يوم",
	calAlarm1h: "قبل ساعة",
	calAlarm1w: "قبل أسبوع",
	calAlarm2d: "قبل يومين",
	calAlarm2h: "قبل ساعتين",
	calAlarm30m: "قبل 30 دقيقة",
	calAlarm5m: "قبل 5 دقائق",
	calAlarmAtEvent: "عند وقت الحدث",
	calAllDay: "طوال اليوم",
	calApiNotConfigured: "واجهة التقويم غير مُعدّة.",
	calCalendarColorLabel: "لون التقويم",
	calCalendarCreateFailed: "تعذر إنشاء التقويم",
	calCalendarCreated: "تم إنشاء التقويم",
	calCalendarDeleted: "تم حذف التقويم",
	calCalendarNameLabel: "اسم التقويم",
	calCalendarNamePh: "مثال: تخطيط الفريق",
	calCalendarNameRequired: "أدخل اسم التقويم",
	calCalendarSelect: "التقويم",
	calCalendarUpdateFailed: "تعذر تحديث التقويم",
	calCalendarUpdated: "تم تحديث التقويم",
	calCalendarsLabel: "التقاويم:",
	calGoogleCalendarLabel: "تقويم Google:",
	calGoogleCalendarPrefix: "Google",
	calMeetingsLabel: "الاجتماعات:",
	calCancel: "إلغاء",
	calCheckAll: "تحديد الكل",
	calColor: "اللون",
	calCreateCalendar: "إنشاء تقويم",
	calDay: "يوم",
	calDayOverviewTitle: "يوم",
	calDefaultCalendarName: "تقويم",
	calDelete: "حذف",
	calDeleteCalendarHasEvents: "يحتوي هذا التقويم على {count} حدث. ماذا تريد أن تفعل بها؟",
	calDeleteCalendarNoEvents: "لا يمكن التراجع عن هذا الإجراء.",
	calDeleteCalendarOnly: "حذف التقويم فقط",
	calDeleteCalendarTitle: "حذف التقويم؟",
	calDeleteCalendarWithEvents: "حذف مع الأحداث",
	calDeleteEventText: "لا يمكن التراجع عن هذا الإجراء.",
	calDeleteEventTitle: "حذف الحدث؟",
	calDeleteFailed: "فشل الحذف",
	calDescription: "الوصف",
	calDescriptionPh: "وصف اختياري",
	calEditCalendarTitle: "تعديل التقويم",
	calEditCalendarTooltip: "تعديل التقويم",
	calEditEvent: "تعديل الحدث",
	calEditTooltip: "تعديل",
	calEnd: "النهاية",
	calEndBeforeStart: "لا يمكن أن يكون النهاية قبل البداية",
	calEndTime: "وقت النهاية",
	calEvent: "حدث",
	calEventCreated: "تم إنشاء الحدث",
	calEventDeleted: "تم حذف الحدث",
	calEventTitle: "العنوان",
	calEventTitlePh: "عنوان الحدث",
	calEventUpdated: "تم تحديث الحدث",
	calEventsPlural: "أحداث",
	calExportIcs: "تصدير .ics",
	calFailedLoadEvents: "فشل تحميل الأحداث",
	calHrBirthdayEvent: "عيد ميلاد",
	calHrBirthdays: "أعياد ميلاد",
	calHrContractEnd: "نهاية العقد",
	calHrContractEndEvent: "نهاية العقد",
	calHrContractStart: "بداية العقد",
	calHrContractStartEvent: "بداية العقد",
	calHrIdEvent: "انتهاء الهوية",
	calHrIdExpiry: "انتهاء الهوية",
	calHrPassportEvent: "انتهاء الجواز",
	calHrPassportExpiry: "انتهاء الجواز",
	calHrPositionReview: "مراجعة المنصب",
	calHrPositionReviewEvent: "مراجعة المنصب",
	calHrSalaryReview: "مراجعة الراتب",
	calHrSalaryReviewEvent: "مراجعة الراتب",
	calImportButton: "استيراد",
	calImportEventsTitle: "استيراد الأحداث",
	calImportFoundInFile: "موجودة في الملف. اختر تقويمًا للاستيراد:",
	calImportIcs: "استيراد .ics",
	calImportedEventTitle: "حدث مستورد",
	calItLabel: "تكنولوجيا المعلومات:",
	calItWarrantyEnd: "انتهاء الضمان",
	calItWarrantyEndEvent: "انتهاء الضمان",
	calMonth: "شهر",
	calNewCalendarTitle: "تقويم جديد",
	calNewEvent: "حدث جديد",
	calNoCalendar: "بدون تقويم",
	calNoCalendarUncategorised: "بدون تقويم (غير مصنف)",
	calNoEventsInIcs: "لا أحداث في ملف .ics",
	calNoEventsThisDay: "لا أحداث في هذا اليوم.",
	calNoRemindersThisDay: "لا تذكيرات في هذا اليوم.",
	calDayWeatherMap: "خريطة الطقس",
	calDayHourlyForecast: "التوقعات بالساعة",
	calDayWeatherUnavailable: "التوقعات غير متاحة لهذا التاريخ",
	calDayEventsSection: "الأحداث",
	calDayRemindersSection: "التذكيرات",
	calOpenProfile: "فتح الملف",
	calPeopleLabel: "الأشخاص:",
	calReminders: "تذكيرات",
	calRemindersLabel: "التذكيرات:",
	calAttendanceLabel: "الحضور:",
	calSecurityLabel: "الأمان:",
	calSecurityAlerts: "التنبيهات",
	calSecuritySessions: "الجلسات",
	calSecurityTokenExpiry: "انتهاء الرمز",
	calRemindersToggle: "التذكيرات النشطة",
	calSave: "حفظ",
	calSaveFailed: "فشل الحفظ",
	calShareWithUsers: "مشاركة مع المستخدمين",
	calShareWithUsersPh: "ابحث واختر الأشخاص",
	calStart: "البداية",
	calStartEndRequired: "مطلوب وقت البداية والنهاية",
	calStartTime: "وقت البداية",
	calSwalDelete: "حذف",
	calTaskHigh: "مرتفع",
	calTaskLow: "منخفض",
	calTaskMedium: "متوسط",
	calTaskUrgent: "عاجل",
	calTasksLabel: "المهام:",
	calTicketsLabel: "التذاكر:",
	calToday: "اليوم",
	calUserFallback: "مستخدم",
	calWeek: "أسبوع",
	calculatePayroll: "احسب الرواتب",
	calculated: "محسوب",
	calculations: "الحسابات",
	calendarEventType: "حدث في التقويم",
	calling: "مكالمة",
	cancel: "إلغاء",
	clearText: "مسح النص",
	cancelAction: "إلغاء الإجراء",
	cancelBack: "إلغاء العودة",
	cancelled: "ملغي",
	cannotBeUndone: "لا يمكن التراجع عن هذا الإجراء.",
	cannotPayOnline: "لا يمكن الدفع عبر الإنترنت",
	cart: "الموظفين",
	categories: "الفئات",
	category: "الفئة",
	categoryPerformance: "أداء الفئة",
	certificate: "شهادة",
	certificateImages: "صور الشهادات",
	certificates: "الشهادات",
	changedDate: "تاريخ التغيير",
	channel: "قناة",
	channelWritePermissionDescription: "يمكن فقط لمشرفي المحادثة كتابة الرسائل",
	channels: "قنوات",
	charts: "الرسوم البيانية",
	chatActions: "اجراءات الدردشة",
	chatActiveLabel: "نشط...",
	chatAddOption: "اضافة خيار",
	chatAddUsers: "إضافة مستخدمين",
	chatAddedToGroupNotification: "تمت إضافتك إلى دردشة جماعية",
	chatAddedYouToGroup: "أضافك إلى",
	chatAudioCall: "مكالمة صوتية",
	chatBulkDeleteFailed: "فشل الحذف الجماعي.",
	chatBulkForwardFailed: "فشلت اعادة التوجيه الجماعية.",
	chatCallMessage: "رسالة مكالمة",
	chatChoosingEmoji: "يختارون ايموجي...",
	chatClickMapToChoosePoint: "انقر على الخريطة لاختيار نقطة مخصصة.",
	chatCoordinatesUnavailable: "الاحداثيات غير متاحة",
	chatCopyCoordinates: "نسخ الاحداثيات",
	chatCopyCoordinatesFailed: "فشل نسخ الاحداثيات.",
	chatCreatePoll: "انشاء استطلاع",
	chatCurrent: "الحالي",
	chatCurrentLocation: "الموقع الحالي",
	chatDashboard: "لوحة تحكم الدردشة",
	chatDeleteFailed: "فشل الحذف",
	chatDeleteForMeOnly: "حذف لي فقط",
	chatDeleteForParticipants: "حذف للمشاركين ايضا",
	chatDeleteLocation: "حذف الموقع",
	chatDeleteSelectedMessagesDescription:
		"يزيل هذا الاجراء الرسائل المحددة من عرض الدردشة. سيتم الابلاغ عن الرسائل التي لا يمكن حذفها بصلاحياتك الحالية كفاشلة.",
	chatDeleteSelectedMessagesTitle: "حذف الرسائل المحددة",
	chatDeletionPartialWarning:
		"قد تكون نتائج الحذف جزئية اذا كانت بعض الرسائل محذوفة بالفعل او فشلت فحوصات الصلاحيات.",
	chatDepartmentSaveFailed: "فشل تحديث القسم",
	chatDepartmentSaveFailedTryAgain: "يرجى محاولة تحديث القسم مرة اخرى.",
	chatDeselectAllMessages: "إلغاء تحديد الكل",
	chatDestinationChatsLabel: "الدردشات الوجهة",
	chatDestinationChatsPlaceholder: "اختر دردشة واحدة او اكثر",
	chatDirect: "محادثة مباشرة",
	chatDirectChat: "دردشة مباشرة",
	chatEditFailed: "تعذر تعديل الرسالة",
	chatEditFailedTryAgain: "يرجى محاولة التعديل مرة أخرى.",
	chatEditMessagePlaceholder: "عدّل الرسالة...",
	writeMessage: "اكتب رسالة...",
	chatEditingMessage: "تعديل الرسالة",
	chatExitSelectionMode: "الخروج من وضع التحديد",
	chatExpired: "منتهي",
	chatForwardFailed: "فشلت اعادة التوجيه",
	chatForwardSelectedMessagesTitle: "اعادة توجيه الرسائل المحددة",
	chatForwardableLabel: "قابلة لاعادة التوجيه",
	chatGeolocationUnavailable: "تحديد الموقع غير متاح في هذا المتصفح.",
	chatGroupChat: "دردشة جماعية",
	chatGroupInfo: "معلومات المجموعة",
	chatGroupMembers: "اعضاء المجموعة",
	chatGroupSettings: "اعدادات المجموعة",
	chatGroupSettingsDescription: "حدد صورة المجموعة وقسم الموارد البشرية المرتبط",
	chatID: "معرف الدردشة",
	chatImageUploadFailed: "فشل تحميل الصورة",
	chatImageUploadFailedTryAgain: "يرجى محاولة تحميل صورة مختلفة.",
	chatIncludeLabel: "تضمين",
	chatIsChoosingEmoji: "يختار ايموجي...",
	chatIsTyping: "يكتب...",
	chatLastUpdated: "اخر تحديث",
	chatLatitude: "خط العرض",
	chatLive: "مباشر",
	chatLiveFor: "مباشر لمدة",
	chatLiveLocation: "موقع مباشر",
	chatLiveLocationOptInWarning: "الموقع المباشر يتطلب موافقة صريحة ويمكن ايقافه في اي وقت.",
	chatLiveLocationSharingActive: "مشاركة الموقع المباشر نشطة",
	chatLoadingLocation: "جار تحميل الموقع...",
	chatLoadingPoll: "جار تحميل الاستطلاع...",
	chatLongitude: "خط الطول",
	chatMessagesCannotBeForwarded: "رسالة/رسائل لا يمكن اعادة توجيهها وسيتم تخطيها.",
	chatMessagesDeleted: "تم حذف الرسائل",
	chatMessagesForwarded: "تمت اعادة توجيه الرسائل",
	chatMoreActions: "المزيد من الاجراءات",
	chatNoAvailableUsersToAdd: "جميع المستخدمين المتاحين موجودون بالفعل في هذه المجموعة.",
	chatNoBackground: "بدون خلفية",
	chatNoChatsFound: "لم يتم العثور على دردشات",
	chatNoMessagesForwarded: "تعذر اعادة توجيه اي رسالة.",
	chatNoSelectedMessagesDeleted: "تعذر حذف اي من الرسائل المحددة.",
	chatOpenDepartmentPage: "افتح صفحة القسم",
	chatOpenMap: "فتح الخريطة",
	chatOptionalAddressLabel: "تسمية عنوان اختيارية",
	chatOwnMessagesLabel: "خاصة بي",
	chatPartialDelete: "حذف جزئي",
	chatPartialForward: "اعادة توجيه جزئية",
	chatPattern: "نمط",
	chatPickOnMap: "اختر على الخريطة",
	chatPickPointOnMap: "اختر نقطة على الخريطة.",
	chatPinnedLocation: "موقع مثبت",
	chatPollAddAnotherOption: "اضافة خيار اخر",
	chatPollAddOptionFailed: "فشلت اضافة الخيار.",
	chatPollAllowAddingOptions: "السماح باضافة خيارات",
	chatPollAllowMultipleAnswers: "السماح باجابات متعددة",
	chatPollAllowRevote: "السماح باعادة التصويت",
	chatPollAnonymous: "استطلاع مجهول",
	chatPollAnonymousCannotAddOptions: "الاختبار المجهول لا يمكنه السماح باضافة خيارات.",
	chatPollAtLeastOptions: "الحد الادنى للخيارات:",
	chatPollAutoClose: "اغلاق تلقائي",
	chatPollChangeVote: "تغيير التصويت",
	chatPollChooseCorrectAnswer: "اختر اجابة صحيحة واحدة على الاقل للاختبار.",
	chatPollCloseDate: "تاريخ الاغلاق",
	chatPollCloseDateOrOpenPeriod: "استخدم تاريخ اغلاق او فترة فتح فقط وليس الاثنين.",
	chatPollCloseFailed: "فشل اغلاق الاستطلاع.",
	chatPollClosePoll: "اغلاق الاستطلاع",
	chatPollCorrectAnswer: "الاجابة الصحيحة",
	chatPollCorrectAnswers: "الاجابات الصحيحة",
	chatPollCreateFailed: "فشل انشاء الاستطلاع.",
	chatPollDeletePoll: "حذف الاستطلاع",
	chatPollDescriptionMax: "يجب ان يكون الوصف بحد اقصى",
	chatPollExplanationMax: "يجب ان يكون الشرح بحد اقصى",
	chatPollHideResultsUntilClosed: "اخفاء النتائج حتى الاغلاق",
	chatPollIncorrectAnswer: "اجابة غير صحيحة",
	chatPollLeaveEmptyKeepOpen: "اتركه فارغا لابقاء الاستطلاع مفتوحا",
	chatPollLeaveEmptyNoTimer: "اتركه فارغا بدون مؤقت",
	chatPollLoadVotersFailed: "فشل تحميل المصوتين.",
	chatPollMultipleChoice: "اختيار متعدد",
	chatPollNewOption: "خيار جديد",
	chatPollNoVoteYet: "لا يوجد تصويت بعد",
	chatPollNoVotersForOption: "لا يوجد مصوتون لهذا الخيار.",
	chatPollOpenPeriod: "فترة الفتح",
	chatPollOptionMax: "يجب ان يكون الخيار بحد اقصى",
	chatPollOptionRequired: "الخيار مطلوب.",
	chatPollOptionsUnique: "يجب ان تكون الخيارات فريدة.",
	chatPollPublic: "عام",
	chatPollQuestionMax: "يجب ان يكون السؤال بحد اقصى",
	chatPollQuestionRequired: "السؤال مطلوب.",
	chatPollQuiz: "اختبار",
	chatPollQuizExplanation: "شرح الاختبار",
	chatPollRegular: "عادي",
	chatPollResultsHiddenUntilClosed: "النتائج مخفية حتى اغلاق الاستطلاع.",
	chatPollSearchVoters: "بحث عن المصوتين",
	chatPollShuffleOptions: "خلط الخيارات",
	chatPollSingleChoice: "اختيار واحد",
	chatPollSingleChoiceOneCorrect: "الاختبار احادي الاختيار يمكن ان يحتوي اجابة صحيحة واحدة فقط.",
	chatPollSubmitVoteFailed: "فشل ارسال تصويتك.",
	chatPollViewVoters: "عرض المصوتين",
	chatPollVoteRecorded: "تم تسجيل التصويت",
	chatPollVotersLabel: "مصوتين",
	chatPollVotersTitle: "مصوتو الاستطلاع",
	chatPollYouVoted: "لقد صوتت.",
	chatPollYouVotedCanChange: "لقد صوتت ويمكنك تغيير اجابتك.",
	chatPreviewChronological: "معاينة (زمني)",
	chatProvider: "الموفر",
	chatReadCurrentLocationFailed: "فشل تحديد موقعك الحالي.",
	chatRefreshCurrentLocation: "تحديث الموقع الحالي",
	chatRuleAllow: "نعم",
	chatRuleDeny: "لا",
	chatRuleTimed: "نعم، لكن لفترة محدودة",
	chatRuleTimerDescription: "مثال: اضبط 1 للسماح بالفعل فقط خلال الدقيقة الأولى بعد الإرسال.",
	chatRuleTimerMinutes: "المؤقت بالدقائق",
	chatSearchMessage: "بحث في الرسائل",
	chatSelectAllMessages: "تحديد الكل",
	chatSelectDepartment: "اختر قسم الموارد البشرية",
	chatSelectOrLoadLocationFirst: "اختر او حمل موقعا اولا.",
	chatSelectRepeatingBackground: "اختر خلفية متكررة",
	chatSelectUsersToAdd: "حدد المستخدمين المراد إضافتهم",
	chatSelectedLabel: "محدد",
	chatSelectionMode: "وضع التحديد",
	chatSendCurrentLocation: "ارسال الموقع الحالي",
	chatSendLocationFailed: "فشل ارسال الموقع.",
	chatSendPinnedLocation: "ارسال الموقع المثبت",
	chatSendVenue: "ارسال المكان",
	chatSentAt: "تم الارسال",
	chatSettings: "اعدادات الدردشة",
	chatSettingsEditRule: "تعديل الرسائل",
	chatSettingsEditRuleDescription:
		"اختر ما إذا كان يمكن تعديل الرسائل دائما أو أبدا أو فقط لمدة محدودة.",
	chatSettingsForwardRule: "إعادة توجيه الرسائل",
	chatSettingsForwardRuleDescription:
		"اسمح بإعادة التوجيه دائما أو امنعها أو اسمح بها لفترة محدودة بعد إرسال الرسالة الأصلية.",
	chatSettingsGlobalPageSubtitle:
		"اضبط قواعد المحادثات الشخصية هنا مرة واحدة. لا يغير قواعد المجموعات إلا مشرفوها.",
	chatSettingsGlobalPageTitle: "إعدادات الدردشة العامة",
	chatSettingsGlobalRulesDescription:
		"تنطبق هذه القواعد على جميع المحادثات الشخصية.",
	chatSettingsGlobalSavedSuccess: "تم تحديث إعدادات الدردشة العامة بنجاح",
	chatSettingsCompactMode: "الوضع المضغوط",
	chatSettingsCompactModeDescription:
		"تقليل المسافات وحجم الصور الرمزية لعرض المزيد من الدردشات في الشريط الجانبي.",
	chatSettingsSidebarDescription: "تحكم في كيفية عرض الدردشات في الشريط الجانبي الأيسر.",
	chatSettingsSidebarTitle: "الشريط الجانبي للدردشة",
	chatSettingsShowLastMessage: "إظهار آخر رسالة",
	chatSettingsShowLastMessageDescription:
		"عرض معاينة آخر رسالة وتاريخها أو وقتها في الشريط الجانبي للدردشة.",
	chatSettingsReplyRule: "الرد على الرسائل",
	chatSettingsReplyRuleDescription:
		"تحكم فيما إذا كان يمكن للأعضاء الرد دائما أو أبدا أو فقط خلال فترة زمنية بعد الإرسال.",
	chatSettingsResetToGlobal: "استعادة قواعد المجموعة الافتراضية",
	chatSettingsRulesAdminOnly: "يمكن فقط لمشرفي الدردشة تغيير هذه القواعد.",
	chatSettingsRulesDescription:
		"اختر ما إذا كان يمكن للأعضاء إعادة التوجيه أو الرد أو التعديل، ويمكنك أيضا تقييد ذلك بوقت.",
	chatSettingsRulesTitle: "قواعد الدردشة",
	chatSettingsSaveFailed: "تعذر حفظ إعدادات الدردشة",
	chatSettingsSaveFailedTryAgain: "يرجى المحاولة مرة أخرى.",
	chatSettingsUsingCustomRules: "تستخدم هذه المجموعة القواعد التي حددها مشرفوها.",
	chatSettingsUsingGlobalRules: "تستخدم هذه المجموعة القواعد الافتراضية.",
	chatShareLocation: "مشاركة الموقع",
	chatSkipLabel: "تخطي",
	chatSkippedLabel: "تم تخطيه",
	chatStartCall: "ابدأ مكالمة",
	chatStartLiveSharing: "بدء المشاركة المباشرة",
	chatStopLiveSharing: "ايقاف المشاركة المباشرة",
	chatType: "نوع المحادثة",
	chatTypeToSearch: "اكتب للبحث",
	chatTyping: "يكتبون...",
	chatUnnamedChat: "دردشة بدون اسم",
	chatUpdatingSharedLocationFor: "يتم تحديث هذا الموقع المشترك لمدة",
	chatUploadGroupImage: "تحميل صورة المجموعة",
	chatUserInfo: "معلومات المستخدم",
	chatUsersSaveFailed: "فشل في إضافة المستخدمين",
	chatUsersSaveFailedTryAgain: "يرجى محاولة إضافة المستخدمين المحددين مرة أخرى.",
	chatVenue: "مكان",
	chatVenueTitle: "عنوان المكان",
	chatVideoCall: "مكالمة فيديو",
	chatViewReportedMessages: "عرض الرسائل المبلغ عنها",
	chatWaitingDeviceCoordinates: "انتظار احداثيات الجهاز...",
	childcarePayment: "دفع رعاية الأطفال",
	chooseBoard: "اختر لوحة لعرض فئاتها ومهامها",
	cities: "المدن",
	city: "مدينة",
	clear: "مسح",
	clearFilters: "مسح المرشحات",
	clickTheButtonBelowToTakeTheNextStepOnYourJourney:
		"انقر فوق الزر أدناه لاتخاذ الخطوة التالية في رحلتك",
	client: "عميل",
	contactEngagement: "تفاعل العملاء",
	contactGroup: "مجموعة العملاء",
	contactGroups: "مجموعات العملاء",
	contactPlaylist: "قائمة تشغيل العميل",
	contactProfile: "ملف العميل",
	clients: "عملاء",
	contactsByGender: "العملاء حسب الجنس",
	contactsByGroup: "العملاء حسب المجموعة",
	contactsUsing: "عملاء يستخدمون",
	contactsWithCarts: "العملاء مع السلال",
	contactsWithFavorites: "العملاء مع المفضلة",
	clockInOut: "الدخول / الخروج",
	close: "إغلاق",
	closeNavigation: "إغلاق التنقل",
	closeTicket: "إغلاق التذكرة",
	closed: "مغلق",
	closed_late: "أُغلق بعد الموعد النهائي",
	closedDate: "تاريخ الإغلاق",
	closedTickets: "التذاكر المغلقة",
	cmDashboard: "لوحة تحكم المحتوى",
	code: "الرمز",
	coin: "عملة",
	coinBurnTime: "وقت حرق العملات",
	coinCount: "عدد العملات",
	color: "لون",
	comment: "تعليق",
	commentTicket: "تعليق التذكرة",
	commissions: "العمولات",
	communicationPreferences: "تفضيلات الاتصال",
	community: "مجتمع",
	company: "شركة",
	completed: "اكتمل",
	completedDate: "تاريخ الانتهاء",
	completedTasks: "المهام المكتملة",
	completionRate: "معدل الإكمال",
	confirm: "تأكيد",
	confirmAction: "تأكيد الإجراء",
	contactForm: "نموذج الاتصال",
	contactForms: "نماذج الاتصال",
	contactType: "نوع الاتصال",
	contacts: "جهات الاتصال",
	contentByType: "المحتوى حسب النوع",
	contentItems: "عناصر المحتوى",
	contentManagementOverview: "نظرة عامة على نظام إدارة المحتوى",
	contentOverTime: "المحتوى المُنشأ بمرور الوقت (آخر 30 يومًا)",
	continue: "متابعة",
	contract: "عقد",
	contractEndDate: "تاريخ انتهاء العقد",
	contractStartDate: "تاريخ بدء العقد",
	contractor: "مقاول",
	copy: "نسخ",
	costOfBuildingPart: "تكلفة جزء البناء",
	costOfBuildingPermit: "تكلفة تصريح البناء",
	country: "بلد",
	cpu: "وحدة المعالجة المركزية",
	create: "طلب",
	createBoard: "إنشاء لوحة جديدة",
	createChat: "إنشاء محادثة",
	createGroupChat: "إنشاء محادثة جماعية",
	createGroupSubmit: "إنشاء",
	addNewCategory: "إضافة فئة جديدة",
	createNewCategory: "إنشاء فئة جديدة",
	created: "تم الإنشاء",
	createdAt: "تم إنشاؤه في",
	createdBy: "تم الإنشاء بواسطة",
	createdByUser: "تم الإنشاء بواسطة المستخدم",
	critical: "حرج",
	crmDashboard: "لوحة تحكم CRM",
	cta1: "اتصل بالإجراء القسم 1",
	cta2: "اتصل بالإجراء القسم 2",
	cta3: "اتصل بالإجراء القسم 3",
	currency: "العملة",
	currentlyStreaming: "يتم البث حاليًا",
	currentlyWorking: "يعمل حاليًا",
	custom: "مخصص",
	customerAcquisition: "اكتساب العملاء",
	customerBaseOverview: "نظرة عامة على قاعدة العملاء",
	customerInsights: "رؤى العملاء",
	customerRelationshipOverview: "نظرة عامة على إدارة علاقات العملاء",
	dashboard: "لوحة القيادة",
	dashboardSubtitle: "عنوان فرعي للوحة التحكم",
	database: "قاعدة البيانات",
	date: "تاريخ",
	dateOfBirth: "تاريخ الميلاد",
	dates: "تواريخ",
	datingAttendance: "حضور المواعيد",
	dayOff: "يوم راحة",
	meeting: "اجتماع",
	dayOffForAllEmployees: "يوم عطلة لجميع الموظفين",
	dayOffRemoved: "تمت إزالة يوم العطلة",
	dayOffSavedForAllEmployees: "تم حفظ يوم العطلة لجميع الموظفين",
	days: "أيام",
	daysLeft: "أيام متبقية",
	daysOfWeek: "أيام الأسبوع",
	daysWorked: "أيام العمل",
	deadLine: "الموعد النهائي",
	deadline: "الموعد النهائي",
	debt: "دين",
	decline: "رفض",
	deductions: "الخصومات",
	defaultEnergyMax: "الطاقة الأقصى الافتراضية",
	defaultEnergyMin: "الطاقة الأدنى",
	defaultStream: "الدفق الافتراضي",
	defaultStreams: "التدفقات الافتراضية",
	defaultStreamsDesc: "التدفقات الافتراضية",
	delays: "تأخيرات",
	delete: "حذف",
	deleteForEveryone: "حذف للجميع",
	deletePermanently: "حذف نهائي",
	deleteRule: "حذف القاعدة",
	deleteSelected: "حذف المحدد",
	delivery: "توصيل",
	deliveryAddress: "عنوان التوصيل",
	deliveryMethod: "طريقة التوصيل",
	density: "الكثافة",
	department: "قسم",
	departmentChatsHelp:
		"اربط محادثات المجموعات والقنوات بهذا القسم. يبقى ذلك متزامنًا مع حقل القسم في كل محادثة.",
	departmentLinkedChats: "محادثات القسم",
	departments: "الأقسام",
	desc: "وصف",
	description: "وصف",
	designer: "مصمم",
	detailedFilters: "مرشحات مفصلة",
	detailedSteps: "الخطوات التفصيلية",
	details: "تفاصيل",
	developed: "مطور",
	developedBy: "تم تطويره من قبل",
	difference: "الفرق",
	diplomaImages: "صور الشهادات",
	directMessages: "رسائل مباشرة",
	disableSteps: "تعطيل الخطوات",
	disabledSteps: "الخطوات المعطلة",
	disk: "القرص",
	distributionByPaymentType: "التوزيع حسب نوع الدفع",
	domainFacility: "المنشأة",
	domainFinance: "المالية",
	domainHR: "HR",
	domainIT: "IT",
	domainOther: "أخرى",
	domainSecurity: "الأمن",
	done: "تم",
	download: "تحميل",
	downloadAsContact: "تنزيل كجهة اتصال",
	draft: "مسودة",
	dragToReorder: "اسحب لإعادة الترتيب",
	dropFilesHere: "اسحب الملفات هنا",
	dropFilesHereOrClick: "اسحب الملفات هنا أو انقر لإضافة المزيد",
	dropzoneText: "اسحب الصور هنا أو انقر لتحديد الملفات",
	dueDate: "تاريخ الموعد",
	duration: "المدة",
	ecommerceDashboard: "لوحة التحكم في التجارة الإلكترونية",
	edit: "تعديل",
	editComment: "تعديل التعليق",
	editItem: "تعديل العنصر",
	editProject: "تحرير المشروع",
	editRule: "تعديل القاعدة",
	edited: "تم التعديل",
	editingRule: "تعديل القاعدة",
	email: "البريد الإلكتروني",
	sendEmail: "إرسال بريد إلكتروني",
	employee: "موظف",
	employeesPerDepartment: "الموظفين لكل قسم",
	employerExpenses: "مصاريف صاحب العمل",
	employmentStatus: "حالة التوظيف",
	emptyTrash: "مسح سلة المهملات",
	end: "نهاية",
	endDate: "تاريخ الانتهاء",
	endDateMustBeLaterThanStartDate: "يجب أن تكون تاريخ الانتهاء في وقت لاحق من تاريخ البدء",
	endDateShort: "تاريخ الانتهاء",
	endOfTraining: "نهاية التدريب",
	endTime: "وقت النهاية",
	ends: "ينتهي",
	energyLevel: "مستوى الطاقة",
	energyScheduling: "خطط الطاقة",
	enterAmount: "أدخل المبلغ",
	enterFeatureSuffix: "أدخل سونيك الخاصية",
	enterFeatureText: "أدخل نص الخاصية",
	enterGroupName: "أدخل اسم المجموعة...",
	enterLabel: "أدخل التسمية",
	enterPersons: "أدخل عدد الأشخاص",
	enterRuleName: "أدخل اسم القاعدة",
	entry: "دخول",
	error: "خطأ",
	errorMessage: "حدث خطأ، يرجى المحاولة مرة أخرى.",
	errorOccurred: "حدث خطأ",
	errorPageButton: "خذني إلى المنزل",
	errorPageHelpText: "تحتاج مساعدة؟ اتصل بفريق الدعم لدينا",
	errorPageSecondaryButton: "الإبلاغ عن هذه المشكلة",
	errorPageSubtitle: "الصفحة التي تبحث عنها غير موجودة",
	errorPageText:
		"لا تقلق، هذا يحدث لأفضلنا! ربما تم نقل الصفحة أو حذفها، أو ربما أدخلت عنوان URL خاطئ. دعنا نعيدك إلى المسار الصحيح.",
	errorPageTitle: "عذراً! حدث خطأ ما",
	errorUserNotFound: "المستخدم غير موجود",
	estimatedHours: "تقدير الوقت",
	eventType: "نوع الحدث",
	exit: "خروج",
	expectedSalary: "الراتب المتوقع",
	expireDate: "تاريخ الانتهاء",
	expired: "منتهي",
	expiresOn: "تنتهي في",
	expiringIdCards: "بطاقات الهوية التي تنتهي صلاحيتها",
	expiringPassports: "جوازات السفر التي تنتهي صلاحيتها",
	export: "تصدير",
	exportData: "تصدير البيانات",
	extraLarge: "كبير جدًا",
	extraSmall: "صغير جدًا",
	faqQuestions: "أسئلة الأسئلة الشائعة",
	favorites: "المفضلة",
	features: "الخصائص",
	female: "أنثى",
	fields: "حقول",
	file: "ملف",
	fileHasBeenRemoved: "تمت إزالة الملف",
	fileMovedToTrash: "تم نقل الملف إلى سلة المهملات",
	fileRestored: "تم استرجاع الملف",
	fileWillBeMovedToTrash: "سيتم نقل الملف إلى سلة المهملات",
	files: "ملفات",
	filesRestored: "تم استرجاع الملفات",
	filesWillBePermanentlyDeleted: "ملفات سيتم حذفها نهائيًا.",
	filter: "مرشح",
	filterBy: "مرشح",
	filters: "مرشحات",
	finish: "إنهاء",
	fired: "تم فصله",
	firstIn: "أول تسجيل دخول",
	firstName: "الاسم الأول",
	forgotPassword: "هل نسيت كلمة المرور؟",
	forward: "إعادة توجيه",
	forwardMessage: "إعادة توجيه الرسالة",
	forwarded: "معاد توجيهه",
	forwardedFrom: "تم إعادة توجيهه من",
	fri: "الجمعة",
	from: "من",
	fromAttendanceLogs: "يُملأ من سجلات الحضور لهذا الموظف والفترة؛ يمكنك التعديل.",
	fromDb: "من قاعدة البيانات",
	fromHrSettings: "إعدادات الموارد البشرية",
	gallery: "المعرض",
	genderDistribution: "توزيع الجنس",
	globalFilter: "مرشح عالمي",
	globalSearchClose: "إغلاق",
	globalSearchCmd_goCalendar_desc: "أحداث التقويم",
	globalSearchCmd_goCalendar_label: "الانتقال إلى التقويم",
	globalSearchCmd_goChat_desc: "فتح المراسلات",
	globalSearchCmd_goChat_label: "الانتقال إلى الدردشة",
	globalSearchCmd_goCrm_desc: "إدارة العملاء",
	globalSearchCmd_goCrm_label: "الانتقال إلى CRM",
	globalSearchCmd_goFinance_desc: "وحدة المالية",
	globalSearchCmd_goFinance_label: "الانتقال إلى المالية",
	globalSearchCmd_goHr_desc: "وحدة الموارد البشرية",
	globalSearchCmd_goHr_label: "الانتقال إلى الموارد البشرية",
	globalSearchCmd_goIt_desc: "معدات تقنية المعلومات",
	globalSearchCmd_goIt_label: "الانتقال إلى تقنية المعلومات",
	globalSearchCmd_goProjects_desc: "قاعدة بيانات المشاريع",
	globalSearchCmd_goProjects_label: "الانتقال إلى المشاريع",
	globalSearchCmd_goRadio_desc: "الموسيقى وقوائم التشغيل",
	globalSearchCmd_goRadio_label: "الانتقال إلى الراديو",
	globalSearchCmd_goTickets_desc: "نظام تذاكر الدعم",
	globalSearchCmd_goTickets_label: "الانتقال إلى التذاكر",
	globalSearchCmd_goTodo_desc: "لوحات ومهام",
	globalSearchCmd_goTodo_label: "الانتقال إلى المهام",
	globalSearchCmd_messageUser_desc: "فتح الدردشة لإرسال رسالة",
	globalSearchCmd_messageUser_label: "مراسلة مستخدم",
	globalSearchCmd_newContact_desc: "إضافة عميل CRM",
	globalSearchCmd_newClient_label: "عميل جديد",
	globalSearchCmd_newOrder_desc: "إنشاء طلب",
	globalSearchCmd_newOrder_label: "طلب جديد",
	globalSearchCmd_newProject_desc: "إنشاء مشروع",
	globalSearchCmd_newProject_label: "مشروع جديد",
	globalSearchCmd_newTask_desc: "إنشاء مهمة",
	globalSearchCmd_newTask_label: "مهمة جديدة",
	globalSearchCmd_newTicket_desc: "إنشاء تذكرة دعم",
	globalSearchCmd_newTicket_label: "تذكرة جديدة",
	globalSearchCommandBadge: "أمر",
	globalSearchCommands: "الأوامر",
	globalSearchCopied: "تم النسخ!",
	globalSearchCopyLink: "نسخ الرابط",
	globalSearchDirectMessage: "رسالة مباشرة",
	globalSearchFilterAll: "الكل",
	globalSearchFilterCalendar: "التقويم",
	globalSearchFilterChats: "الدردشات",
	globalSearchFilterDevices: "الأجهزة",
	globalSearchFilterEcom: "التجارة الإلكترونية",
	globalSearchFilterFinance: "المالية",
	globalSearchFilterPeople: "الأشخاص",
	globalSearchFilterProjects: "المشاريع",
	globalSearchFilterRadio: "الراديو",
	globalSearchFilterTickets: "التذاكر",
	globalSearchFilterTodo: "المهام",
	globalSearchHidePreview: "إخفاء المعاينة",
	globalSearchNavigate: "تنقل",
	globalSearchOpen: "فتح",
	globalSearchOpenInNewTab: "فتح في علامة تبويب جديدة",
	globalSearchPageBadge: "صفحة",
	globalSearchPlaceholder: "ابحث في APIT عن أي شيء (مستخدمون، تذاكر، محادثات، أجهزة…)",
	globalSearchPreviewAddress: "العنوان",
	globalSearchPreviewArtist: "الفنان",
	globalSearchPreviewChat: "الدردشة",
	globalSearchPreviewCompany: "الشركة",
	globalSearchPreviewCreated: "تاريخ الإنشاء",
	globalSearchPreviewDeviceId: "معرف الجهاز",
	globalSearchPreviewEmail: "البريد",
	globalSearchPreviewEmployeeNumber: "رقم الموظف",
	globalSearchPreviewEnd: "النهاية",
	globalSearchPreviewInfo: "معلومات",
	globalSearchPreviewIp: "IP",
	globalSearchPreviewLocation: "الموقع",
	globalSearchPreviewMac: "MAC",
	globalSearchPreviewNumber: "الرقم",
	globalSearchPreviewOrderNumber: "رقم الطلب",
	globalSearchPreviewPhone: "الهاتف",
	globalSearchPreviewSent: "أُرسل",
	globalSearchPreviewStart: "البداية",
	globalSearchPreviewUsername: "اسم المستخدم",
	globalSearchPreviewVendor: "المورد",
	globalSearchPreviewVersion: "الإصدار",
	globalSearchRecentSearches: "عمليات البحث الأخيرة",
	globalSearchRecentlyOpened: "المفتوحة مؤخرًا",
	globalSearchSectionArtists: "الفنانون",
	globalSearchSectionAttendanceDevices: "أجهزة الحضور",
	globalSearchSectionBrands: "العلامات",
	globalSearchSectionCalendarEvents: "أحداث التقويم",
	globalSearchSectionCameras: "الكاميرات",
	globalSearchSectionChats: "الدردشات",
	globalSearchSectionClientGroups: "مجموعات العملاء",
	globalSearchSectionClients: "العملاء",
	globalSearchSectionCpus: "المعالجات",
	globalSearchSectionDepartments: "الأقسام",
	globalSearchSectionEcomCategories: "الفئات",
	globalSearchSectionFinanceCardIssuers: "مُصدِرو البطاقات",
	globalSearchSectionFinanceCards: "البطاقات",
	globalSearchSectionFinanceCategories: "فئات مالية",
	globalSearchSectionFinanceTransactions: "المعاملات",
	globalSearchSectionGpus: "بطاقات الرسومات",
	globalSearchSectionKeyboards: "لوحات المفاتيح",
	globalSearchSectionLaptops: "أجهزة كمبيوتر محمولة",
	globalSearchSectionMessages: "الرسائل",
	globalSearchSectionMice: "فأرات",
	globalSearchSectionMonitors: "الشاشات",
	globalSearchSectionOrders: "الطلبات",
	globalSearchSectionPcs: "أجهزة الكمبيوتر",
	globalSearchSectionPlaylists: "قوائم التشغيل",
	globalSearchSectionPositions: "المناصب",
	globalSearchSectionPrinters: "الطابعات",
	globalSearchSectionProblems: "المشكلات",
	globalSearchSectionProducts: "المنتجات",
	globalSearchSectionProjects: "المشاريع",
	globalSearchSectionRams: "الذاكرة العشوائية",
	globalSearchSectionRoms: "التخزين",
	globalSearchSectionRooms: "الغرف",
	globalSearchSectionRouters: "أجهزة التوجيه",
	globalSearchSectionSmbs: "SMB",
	globalSearchSectionSoftware: "البرمجيات",
	globalSearchSectionSwitches: "المحولات",
	globalSearchSectionTelephones: "هواتف",
	globalSearchSectionTickets: "التذاكر",
	globalSearchSectionTodoBoards: "اللوحات",
	globalSearchSectionTodoCategories: "الفئات",
	globalSearchSectionTodoTasks: "المهام",
	globalSearchSectionTracks: "المقاطع",
	globalSearchSectionUsers: "الأشخاص",
	globalSearchSectionWarrantyProviders: "مزودو الضمان",
	globalSearchSelectPreview: "حدد عنصرًا للمعاينة",
	globalSearchShortcutHint: "Ctrl + K",
	globalSearchShowPreview: "إظهار المعاينة",
	globalSearchSubtitle: "البحث في جميع الوحدات",
	globalSearchSuggest1: "البحث عن التذاكر المعينة لي",
	globalSearchSuggest2: "العثور على موظف بالبريد",
	globalSearchSuggest3: "البحث في رسائل الدردشة",
	globalSearchSuggest4: "العثور على جهاز بعنوان IP",
	globalSearchSuggest5: "البحث عن عميل بالهاتف",
	globalSearchSuggest6: "الانتقال إلى المشاريع",
	globalSearchTrySearchingFor: "جرّب البحث عن",
	goBack: "العودة",
	goToMessage: "الانتقال إلى الرسالة",
	goToUserAttendanceTab: "المستخدمون → الحضور",
	goToUserAttendanceTabTooltip: "فتح هذا الموظف في مستخدمي الموارد البشرية في تبويب الحضور",
	gpu: "وحدة معالجة الرسومات",
	grossSalary: "الراتب الإجمالي",
	group: "مجموعة",
	groupChat: "محادثة جماعية",
	groupChatWritePermissionDescription: "يمكن لجميع أعضاء المحادثة كتابة الرسائل",
	groupChats: "محادثات جماعية",
	groupName: "اسم المجموعة (اختياري)",
	healthInsurance: "التأمين الصحي",
	healthInsuranceBenefit: "التأمين الصحي (مزية)",
	help: "مساعدة",
	hideAllSteps: "إخفاء جميع الخطوات",
	hideHistory: "إخفاء التاريخ",
	hideProjectDetails: "إخفاء تفاصيل المشروع",
	hideTableColumnFilters: "إخفاء مرشحات الأعمدة",
	hideTimeline: "إخفاء الجدول الزمني",
	high: "عالي",
	highestSpendingCustomers: "العملاء الأكثر إنفاقاً",
	highlight: "تمييز",
	highlightFeature: "تمييز الخاصية",
	history: "التاريخ",
	historyTable: "جدول التاريخ",
	holiday: "عطلة رسمية",
	holidayNonWorking: "عطلة / يوم غير عمل",
	hourlyRate: "الأجر بالساعة",
	hourlyRateBaseLinked:
		"يحدّث الراتب الأساسي من الأجر بالساعة × الساعات العادية (عندما الساعات > 0).",
	hr2025RateReferenceTables: "جداول مرجعية للأسعار 2025",
	hrAccrualAnnualTotal: "الإجمالي السنوي: {amount} يوم",
	hrAccrualDaily: "يومي (÷ 365)",
	hrAccrualEachDay: "كل يوم: +{amount} يوم إجازة",
	hrAccrualEachMonthFirst: "كل أول شهر: +{amount} يوم إجازة",
	hrAccrualMethod: "طريقة الاستحقاق",
	hrAccrualMethodDesc: "كيف تتراكم الإجازة",
	hrAccrualMonthly: "شهري (÷ 12، في اليوم الأول)",
	hrAccrualMonthlyEquivalent: "المعادل الشهري: ~{amount} يوم",
	hrAccrualPreview: "معاينة الاستحقاق",
	hrArmeniaIncomeTaxCalculator: "حاسبة ضريبة الدخل (أرمينيا)",
	hrArmeniaTaxRates: "معدلات الضريبة في أرمينيا",
	hrCalcSummaryGrossToNet:
		"لراتب مسجل {gross} درام، ستستلم {net} درام بعد خصم {deductions} درام كضرائب ومساهمات.",
	hrCalcSummaryNetToGross:
		"لاستلام {net} درام صافياً، يجب أن يظهر في العقد راتب إجمالي {gross} درام.",
	hrCalculationBreakdown: "تفصيل الحساب",
	hrCalculationDirection: "اتجاه الحساب",
	hrDefaultBenefitsDescription:
		"تُطبق هذه القيم الافتراضية على جميع حسابات الرواتب ما لم يُستبدل لكل موظف.",
	hrDefaultMonthlyBenefits: "المزايا الشهرية الافتراضية (درام)",
	hrDesiredNetSalaryLabel: "صافي الراتب المطلوب (المستلم)",
	hrEmployeePensionLabel: "معاش التقاعد للموظف:",
	hrEmployeePensionRate: "معدل معاش التقاعد للموظف",
	hrEmployeePensionRateDesc: "إلزامي للمواليد بعد 1973 (2.5%)",
	hrEmployerPensionRate: "معدل مساهمة صاحب العمل في التقاعد",
	hrEmployerPensionRateDesc: "مساهمة صاحب العمل في التقاعد (2.5%)",
	hrFailedToSaveSettings: "فشل حفظ الإعدادات",
	hrGrossSalaryAMD: "الراتب الإجمالي (درام)",
	hrGrossSalaryDescription: "أدخل المبلغ الوارد في عقد العمل",
	hrGrossSalaryLabel: "الراتب الإجمالي (المسجل / مبلغ العقد)",
	hrGrossSalaryRegistered: "الراتب الإجمالي (المسجل)",
	hrGrossToNet: "إجمالي → صافٍ",
	hrHealthInsuranceAges: "التأمين الصحي (18–65 سنة)",
	hrHealthInsuranceBenefit: "التأمين الصحي",
	hrHealthInsuranceBenefitDesc: "مساهمة صاحب العمل الشهرية في التأمين الصحي (درام)",
	hrHealthInsuranceEmployeeColumn: "الموظف",
	hrHealthInsuranceEmployeeShare: "التأمين الصحي (حصة الموظف)",
	hrHealthInsuranceStateColumn: "الدولة",
	hrITSector: "قطاع تقنية المعلومات (ضريبة دخل 10٪)",
	hrITSectorDesc: "موظف في شركة تقنية معلومات مرخّصة",
	hrIncomeTax: "ضريبة الدخل",
	hrIncomeTaxLabel: "ضريبة الدخل:",
	hrIncomeTaxRate: "معدل ضريبة الدخل",
	hrIncomeTaxRateDesc: "ثابت 20٪ في أرمينيا منذ 2020",
	hrLeaveAccrualConfiguration: "إعداد استحقاق الإجازة",
	hrLiveRates: "أسعار حالية",
	hrLunchCoverage: "تغطية الغداء",
	hrLunchCoverageDesc: "بدل غداء/طعام شهري (درام)",
	hrMandatoryHealthInsurance: "التأمين الصحي الإلزامي (18–65)",
	hrMandatoryHealthInsuranceDesc: "تضمين شرائح التأمين الصحي لعام 2025",
	hrMilitaryStampRate: "معدل الرسم العسكري",
	hrMilitaryStampRateDesc: "اتركه 0 إذا لا ينطبق",
	hrMonthlyFee: "الرسوم الشهرية",
	hrNetSalaryDescription: "أدخل المبلغ الذي تريد استلامه فعلياً",
	hrNetSalaryLabel: "صافي الراتب:",
	hrNetSalaryTakeHome: "صافي الراتب (المستلم)",
	hrNetToGross: "صافٍ → إجمالي",
	hrOvertimeRateMultiplier: "مضاعف أجر العمل الإضافي",
	hrOvertimeRateMultiplierDesc: "مثلاً 1.5× تعني علاوة 50٪ للعمل الإضافي",
	hrOvertimeRules: "قواعد العمل الإضافي",
	hrBreakIntervals: "فترات الاستراحة",
	hrBreakIntervalsDesc:
		"فترات زمنية يومية ثابتة (مثل الغداء) مستبعدة من ساعات العمل للجميع. يمكنك إضافة أكثر من فترة.",
	hrBreakIntervalsEmpty: "لم يتم تكوين أي فترة استراحة",
	hrBreakIntervalStart: "بداية الاستراحة",
	hrBreakIntervalEnd: "نهاية الاستراحة",
	hrAddBreakInterval: "إضافة استراحة",
	hrOvertimeThreshold: "حد العمل الإضافي (ساعات/يوم)",
	hrOvertimeThresholdDesc: "الساعات فوق هذا الحد تُحسب بسعر العمل الإضافي",
	hrPensionMandatory: "إلزامي / تطوعي قبل 07/2018 (٥٪)",
	hrPensionNone: "غير مشارك (٠٪)",
	hrPensionPost2018: "تطوعي بعد 07/2018 (٥٪)",
	hrPensionSystem: "نظام التقاعد",
	hrPensionSystemDesc: "حالة مشاركتك في التقاعد الممول",
	hrSettingsPageSubtitle: "اضبط كشوف المرتبات والإجازات وقواعد الحضور",
	hrSettingsPageTitle: "إعدادات الموارد البشرية",
	hrSettingsUpdatedSuccessfully: "تم تحديث إعدادات الموارد البشرية بنجاح",
	hrSickDaysPerYear: "أيام المرضى في السنة",
	hrSickDaysPerYearDesc: "أيام الإجازة المرضية المدفوعة بالسنة التقويمية",
	hrSocialPaymentPension: "الدفع الاجتماعي (التقاعد)",
	hrSocialTaxRate: "معدل الضريبة الاجتماعية",
	hrSocialTaxRateDesc: "حالياً 0٪ في أرمينيا (استُبدلت بمساهمات التقاعد)",
	hrStampFee: "رسم الطابع (صندوق التأمين العسكري)",
	hrStampFeeTooltip: "صندوق التأمين العسكري — رسوم ثابتة متدرجة حسب شريحة الراتب الإجمالي",
	hrStandardWorkSchedule: "جدول عمل قياسي",
	hrStateHealthContribution: "مساهمة الدولة في الصحة",
	hrStateHealthContributionNote: "يضافها الدولة لباقة التأمين الصحي (لا يُخصم من راتبك).",
	hrSuffixDays: "يوم",
	hrSuffixHours: "س",
	hrSuffixTimes: "×",
	hrSummary: "ملخص",
	hrTabDefaultBenefits: "المزايا الافتراضية",
	hrTabLeaveAccrual: "استحقاق الإجازة",
	hrTabTaxCalculator: "حاسبة الضرائب",
	hrTabTaxesArmenia: "الضرائب (أرمينيا)",
	hrTabWorkSchedule: "جدول العمل",
	hrTaxPreviewTitle: "معاينة الضريبة (على 500 000 درام إجمالي)",
	hrTaxRatesDescription: "تُطبق المعدلات على الراتب الإجمالي. أدخل كنسب مئوية (مثلاً 20 = 20٪).",
	hrTaxRatesDisclaimer:
		"الأسعار وفق تشريعات أرمينيا 2025–2026. ضريبة الدخل: 20٪ قياسية، 10٪ لشركات تقنية مرخّصة. التقاعد: 5٪ (إلزامي/تطوعي قبل 2018) أو 5٪ ثابت (تطوعي بعد 2018). يطبق 10٪ الزائدة على المشاركين الإلزاميين/ما قبل 2018 فوق 500 ألف درام. يُنصح بمراجعة محاسب معتمد.",
	hrThresholdWarning: "تحذير عتبة",
	hrThresholdWarningText:
		"راتبك قرب حد شريحة (100 ألف / 200 ألف / 500 ألف / 1 مليون درام). عندها ترتفع الرسوم والتأمين الصحي، فقد يقل الصافي رغم زيادة بسيطة في الإجمالي. يعرض الحاسبة أقل إجمالي يحقق الصافي المطلوب.",
	hrTickets: "تذاكر HR",
	hrTotalDeductions: "إجمالي الخصومات",
	hrTotalEmployeeDeductionsLabel: "إجمالي خصومات الموظف:",
	hrTransportAllowance: "بدل النقل",
	hrTransportAllowanceDesc: "مزية نقل شهرية (درام)",
	hrVacationDaysPerYear: "أيام الإجازة السنوية",
	hrVacationDaysPerYearDesc: "الاستحقاق السنوي الكامل (الحد الأدنى في أرمينيا: 20)",
	hrWorkingDayEnd: "نهاية يوم العمل",
	hrWorkingDayEndDesc: "وقت نهاية الوردية المتوقع. يتم اشتقاق ساعات اليوم من وقتي البداية والنهاية",
	hrWorkingDayStart: "بداية يوم العمل",
	hrWorkingDayStartDesc: "وقت الحضور المتوقع لاحتساب الدوام والتأخير",
	hrWeekendDays: "أيام عطلة نهاية الأسبوع",
	hrWeekendDaysDesc: "حدد أيام الأسبوع التي تعتبر عطلة نهاية أسبوع غير عمل",
	hrWorkingDaysPerWeek: "أيام العمل في الأسبوع",
	hrWorkingDaysPerWeekDesc: "الإثنين–الجمعة = 5، الإثنين–السبت = 6",
	hrWorkingHoursPerDay: "ساعات العمل يومياً",
	hrWorkingHoursPerDayDesc: "الساعات القياسية قبل بدء العمل الإضافي",
	href: "رابط",
	humanResources: "الموارد البشرية",
	id: "معرف",
	idCard: "بطاقة الهوية",
	idCardEndDate: "تاريخ انتهاء بطاقة الهوية",
	idCardNo: "رقم بطاقة الهوية",
	idCardStartDate: "تاريخ بدء بطاقة الهوية",
	idCart: "بطاقة الهوية",
	image: "صورة",
	immediateSupervisor: "المشرف المباشر",
	importance: "أهمية",
	important: "مهم",
	inProgress: "قيد التقدم",
	inSelectedPeriod: "في الفترة المحددة",
	inStock: "متوفر",
	in_progress: "في المهمة",
	inactive: "غير نشط",
	inactiveTime: "وقت غير نشط",
	incident: "حادثة",
	incomeTaxAmount: "مبلغ ضريبة الدخل",
	incomeTaxRate: "معدل ضريبة الدخل (٪)",
	incomingCall: "مكالمة واردة",
	incomingVideoCall: "مكالمة فيديو واردة",
	incorrectLogin: "أدخلت اسم مستخدم أو كلمة مرور غير صحيحة",
	index: "#",
	inputInArmenian: "الإدخال باللغة الأرمنية",
	inputInLatin: "الإدخال باللاتينية",
	inputInNumbers: "أدخل بالأرقام",
	inputInRussian: "الإدخال باللغة الروسية",
	inputNumber: "إدخال الرقم",
	inputNumbers: "أدخل الأرقام",
	instagramPosts: "منشورات إنستغرام",
	insufficientVacationBalance: "رصيد الإجازة غير كافٍ",
	interview1: "مقابلة",
	interview2: "تعرف",
	interview3: "تدريب",
	interview4: "تدريب عملي",
	interviewDate: "تاريخ المقابلة",
	interviewTime: "وقت المقابلة",
	introSection: "قسم المقدمة",
	invalidDate: "تاريخ التسليم غير صالح",
	inventorySummary: "ملخص المخزون",
	ip: "IP",
	ipAddress: "عنوان IP",
	isActive: "نشط",
	isColor: "اللون",
	isPrivateOffice: "هل هو مكتب خاص",
	isPublic: "عام",
	itTickets: "تذاكر IT",
	items: "عناصر",
	justifiedAbsence: "غياب مبرر",
	keyText: "النص الأساسي",
	keyboards: "لوحات المفاتيح",
	label: "التسمية",
	language: "اللغة",
	languagePickerLabel: "لغة",
	large: "كبير",
	last7Days: "تسجيل الدخول خلال آخر 7 أيام",
	lastAction: "آخر إجراء",
	lastLogin: "آخر تسجيل دخول",
	lastName: "اللقب",
	lastOut: "آخر خروج",
	lastPunch: "اخر تسجيل حضور",
	lasts: "المدة",
	latestCustomerOrders: "أحدث طلبات العملاء",
	leader: "قائد",
	attendanceManagersFilter: "المديرون",
	attendanceLeadersFilter: "القادة",
	leaveBalance: "رصيد الإجازات",
	linkCopied: "تم نسخ الرابط",
	listeners: "المستمعين",
	livingAddress: "عنوان السكن",
	loading: "جارٍ التحميل",
	loanDeductions: "خصومات القرض",
	localCode: "الرمز المحلي",
	logOut: "تسجيل الخروج",
	login: "تسجيل الدخول",
	loginButton: "تسجيل الدخول",
	loginFailed: "فشل تسجيل الدخول",
	loginFailedMessage: "يرجى التحقق من بيانات تسجيل الدخول الخاصة بك",
	loginSuccess: "تم تسجيل الدخول بنجاح",
	loginSuccessMessage: "لقد سجلت الدخول بنجاح",
	loginToStartSession: "تسجيل الدخول لبدء الجلسة",
	logout: "تسجيل الخروج",
	low: "منخفض",
	lunchCoverage: "تغطية الغداء",
	mac: "MAC",
	macAddress: "عنوان MAC",
	main: "رئيسي",
	itHierarchyAddLaptop: "إضافة حاسوب محمول",
	itHierarchyAttachedPc: "جهاز الكمبيوتر المتصل",
	itHierarchyLaptopsUsingPart: "الحواسيب المحمولة التي تستخدم هذا الجزء",
	itUsedInOtherPlaces: "مستخدم في أماكن أخرى",
	mainInformation: "معلومات أساسية",
	mainInfo: "المعلومات الأساسية",
	contactInfo: "معلومات الاتصال",
	personalInfo: "المعلومات الشخصية",
	workingInfo: "معلومات العمل",
	probation: "فترة تجريبية",
	educationInfo: "معلومات التعليم",
	male: "ذكر",
	manualAdjustments: "تعديلات يدوية",
	manualAttendanceEntry: "إدخال يدوي",
	maps: "خرائط",
	maritalStatus: "الحالة الاجتماعية",
	markAllAsRead: "وضع علامة مقروء على الكل",
	markSelectedAsRead: "وضع علامة مقروء على المحدد",
	maternityLeave: "إجازة الأمومة",
	maxEnergy: "الطاقة الأقصى",
	maxFilesReached: "الحد الأقصى للملفات المسموح به تم الوصول إليه",
	maxSize: "الحجم الأقصى",
	mediaGallery: "معرض الوسائط",
	mediaGalleryDescription: "وصف معرض الوسائط",
	mediator: "وسيط",
	medium: "متوسط",
	members: "أعضاء",
	menu: "القائمة",
	message: "رسالة",
	messages: "رسائل",
	messagesByType: "الرسائل حسب النوع",
	messagesOverTime: "الرسائل بمرور الوقت (آخر 30 يومًا)",
	militaryStampAmount: "مبلغ الرسم العسكري",
	militaryStampRate: "معدل الرسم العسكري",
	minEnergy: "الطاقة الأدنى",
	minute: "دقيقة",
	minutes: "دقائق",
	missingInterval: "فترة مفقودة",
	mon: "الإثنين",
	monitor: "شاشة",
	monitors: "شاشات",
	month: "الشهر",
	monthly: "شهري",
	mood: "Mood",
	more: "إضافي",
	moreDetailed: "أكثر تفصيلاً",
	moreThan: "أكثر من",
	motherProject: "المشروع الأم",
	mounted: "مثبت",
	mouses: "فأرات",
	moveToTrash: "نقل إلى سلة المهملات",
	movedToTrash: "تم نقل الملف إلى سلة المهملات",
	myActiveSteps: "خطواتي النشطة",
	myInvolvement: "مشاركتي",
	myProjects: "مشاريعي",
	myRole: "دوري",
	mySteps: "خطواتي",
	myTickets: "تذاكري",
	na: "غير متاح",
	name: "الاسم",
	netCash: "الصافي النقدي",
	netOfficial: "الصافي الرسمي",
	netSalary: "الراتب الصافي",
	newClients: "عملاء جدد",
	newClientsOverTime: "عملاء جدد بمرور الوقت (آخر 30 يومًا)",
	newMessage: "رسالة جديدة",
	newProducts: "منتجات جديدة",
	newProject: "مشروع جديد",
	newProjects: "مشاريع جديدة",
	newThisPeriod: "جديد هذه الفترة",
	newTicket: "تذكرة جديدة",
	newTicketCreatedBy: "تم إنشاء تذكرة جديدة بواسطة",
	newTracks: "مسارات جديدة",
	newTracksOverTime: "مسارات جديدة بمرور الوقت (آخر 30 يومًا)",
	next: "التالي",
	nextComposition: "التكوين التالي",
	nextStep: "الخطوة التالية",
	noAccess: "لا يوجد وصول",
	noActiveSteps: "لا توجد خطوات نشطة",
	noBoardsFound: "لا يوجد لوحات",
	noCategoriesFound: "لا يوجد فئات",
	noCategoryDataAvailable: "لا توجد بيانات فئة متاحة",
	noContent: "لا يوجد محتوى",
	noCustomerDataAvailable: "لا توجد بيانات عملاء متاحة",
	noData: "لا توجد بيانات",
	noDataAvailable: "لا توجد بيانات متاحة",
	noDataAvailableForSelectedPeriod: "لا توجد بيانات للفترة المحددة",
	noDepartment: "لا يوجد قسم",
	noDepartments: "لا توجد أقسام",
	noDescription: "وصف غير موجود",
	noEmail: "لا يوجد بريد إلكتروني",
	noExpiringIdCards: "لا توجد بطاقات هوية منتهية الصلاحية",
	noExpiringPassports: "لا توجد جوازات سفر منتهية الصلاحية",
	noGroup: "بدون مجموعة",
	noMediaDescription: "وصف الوسائط غير موجود",
	noMediaFound: "لا يوجد وسائط",
	noMoreItems: "لا يوجد أكثر",
	noName: "بدون اسم",
	noNeedStep45: "لا حاجة للخطوة 4-5",
	noNotifications: "لا إشعارات",
	noOrdersInSelectedPeriod: "لا توجد طلبات في الفترة المحددة",
	noOvertimeRecords: "لا توجد سجلات عمل إضافي",
	noPaymentDataAvailable: "لا توجد بيانات دفع متاحة",
	noProjectsAssigned: "لا توجد مشاريع معينة",
	noProjectsAssignedOrInvolved: "لا توجد مشاريع معينة أو متورطة",
	noRecentContacts: "لا يوجد عملاء حديثون",
	noRecentContent: "لا يوجد محتوى حديث",
	noRecentTickets: "لا توجد تذاكر حديثة",
	noRecentTracks: "لا توجد مسارات حديثة",
	noRecipientInformation: "لا توجد معلومات عن المستلم",
	noResponsible: "لا يوجد مسؤول",
	noResult: "لا يوجد نتائج",
	noResults: "لا يوجد نتائج",
	noResultsFound: "لم يتم العثور على نتائج",
	noRulesAdded: "قواعد التخطيط لم تضاف",
	noStatusData: "لا توجد بيانات الحالة",
	noSystemDaysOffThisMonth: "لا أيام عطلة عامة في النظام هذا الشهر",
	noTaskDataAvailable: "لا توجد بيانات متاحة",
	noTasksYet: "لا يوجد مهام",
	noTasksYetDescription: "لا يوجد مهام",
	noUpcomingBirthdays: "لا توجد أعياد ميلاد قادمة",
	noUsersFound: "لم يتم العثور على مستخدمين",
	noUsersInDepartment: "لا يوجد مستخدمون في هذا القسم",
	noWorkHourData: "لا توجد بيانات ساعات العمل",
	no_priority: "بدون اولویت",
	nonWorking: "يوم غير عمل",
	none: "لا يوجد",
	notAvailable: "المنتج غير متاح",
	notCorrectLoginCredentials: "بيانات تسجيل الدخول غير صحيحة",
	notLoggedInToday: "لم يتم تسجيل الدخول اليوم",
	notPlaced: "لم توضع",
	notPresent: "غير موجود",
	notResponded: "لم يتم الرد",
	notWorking: "غير موجود",
	deviceProblems: "مشكلات الأجهزة",
	openTickets: "التذاكر المفتوحة",
	note: "ملاحظة",
	nothingFound: "لم يتم العثور على شيء",
	notifications: "الإشعارات",
	notificationsBellAria: "فتح الإشعارات",
	similarTicketNotifications: "إشعارات التذاكر المماثلة",
	number: "رقم",
	"office-map": "خريطة المكتب",
	officeMapActivatePlacement: "تفعيل التحديد",
	officeMapAgent: "الوكيل",
	officeMapAll: "الكل",
	officeMapAttendanceDevice: "جهاز الحضور",
	officeMapAttendanceDevices: "الحضور",
	officeMapCable: "كابل",
	officeMapCableLinePlaced: "تم وضع خط الكابل",
	officeMapCableRemovedFromMap: "تمت إزالة الكابل من الخريطة",
	officeMapCables: "الكابلات",
	officeMapCamera: "كاميرا",
	officeMapCameras: "الكاميرات",
	officeMapNvr: "مسجّل فيديو شبكي (NVR)",
	officeMapChat: "دردشة",
	officeMapChatWasNotCreated: "لم يتم إنشاء الدردشة",
	officeMapConnectToCamera: "الاتصال بالكاميرا",
	officeMapCpu: "CPU",
	officeMapDeactivate: "إلغاء التفعيل",
	officeMapDeviceDetails: "تفاصيل الجهاز",
	officeMapDeviceId: "معرّف الجهاز",
	officeMapDisableDragging: "تعطيل السحب",
	officeMapEnableDragging: "تفعيل السحب",
	officeMapEndDeviceOptional: "جهاز النهاية (اختياري)",
	officeMapFailedToMoveCable: "فشل نقل الكابل",
	officeMapFailedToMoveItem: "فشل نقل العنصر",
	officeMapFailedToMoveRoomArea: "فشل نقل منطقة الغرفة",
	officeMapFailedToOpenChat: "فشل فتح الدردشة",
	officeMapFailedToPlaceItem: "فشل وضع العنصر",
	officeMapFailedToPlaceUser: "فشل وضع المستخدم",
	officeMapFailedToRemoveCable: "فشلت إزالة الكابل",
	officeMapFailedToRemoveItem: "فشل إزالة العنصر",
	officeMapFailedToRemoveRoomArea: "فشلت إزالة منطقة الغرفة",
	officeMapFailedToSaveCableLine: "فشل حفظ خط الكابل",
	officeMapFailedToSaveRoomArea: "فشل حفظ منطقة الغرفة",
	officeMapFinishArea: "إنهاء المنطقة",
	officeMapFinishCable: "إنهاء الكابل",
	officeMapForbidden: "ممنوع",
	officeMapIp: "IP",
	officeMapItem: "عنصر",
	officeMapItemPlaced: "تم وضع العنصر",
	officeMapItemRemovedFromMap: "تمت إزالة العنصر من الخريطة",
	officeMapLaptop: "كمبيوتر محمول",
	officeMapLaptops: "أجهزة كمبيوتر محمولة",
	officeMapLayers: "الطبقات",
	officeMapLinkedItRoom: "غرفة تقنية المعلومات المرتبطة",
	officeMapLive: "مباشر",
	officeMapMac: "MAC",
	officeMapMin: "الحد الأدنى",
	officeMapMonitors: "الشاشات",
	officeMapNetworkCable: "كابل الشبكة",
	officeMapNoDevicesInArea: "لا توجد أجهزة أو مستخدمون موضوعون في هذه المنطقة.",
	officeMapNoPermissionToPlaceItem: "ليس لديك إذن لوضع هذا العنصر.",
	officeMapNoPermissionToPlaceNetworkCable: "ليس لديك إذن لوضع كابل شبكة.",
	officeMapNoPermissionToPlaceRoomArea: "ليس لديك إذن لوضع منطقة غرفة.",
	officeMapNoPermissionToRemoveItem: "ليس لديك إذن لإزالة هذا العنصر من الخريطة.",
	officeMapNoPermissionToRemoveNetworkCable: "ليس لديك إذن لإزالة كابل الشبكة من الخريطة.",
	officeMapNoPermissionToRemoveRoomArea: "ليس لديك إذن لإزالة منطقة الغرفة من الخريطة.",
	officeMapNotAvailable: "غير متوفر",
	officeMapNotConnected: "غير متصل",
	officeMapPc: "كمبيوتر",
	officeMapPcs: "أجهزة الكمبيوتر",
	officeMapPlacement: "تحديد الموقع",
	officeMapPleaseSelectItemFirst: "يرجى اختيار عنصر أولاً",
	officeMapPleaseSelectRoomFirst: "يرجى اختيار غرفة أولاً",
	officeMapPoints: "النقاط",
	officeMapPorts: "المنافذ",
	officeMapPrinted: "تمت الطباعة",
	officeMapPrinters: "الطابعات",
	officeMapRam: "RAM",
	officeMapRemoveFromMap: "إزالة من الخريطة",
	officeMapRom: "ROM",
	officeMapRoomArea: "منطقة الغرفة",
	officeMapRoomAreaPlaced: "تم وضع منطقة الغرفة",
	officeMapRoomAreaRemovedFromMap: "تمت إزالة منطقة الغرفة من الخريطة",
	officeMapRoomAreas: "الغرف",
	officeMapRoomContents: "محتويات الغرفة",
	officeMapRouter: "موجّه",
	officeMapRouters: "الموجّهات",
	officeMapSelectItem: "اختر العنصر",
	officeMapSelectRoom: "اختر الغرفة",
	officeMapSpeed: "السرعة",
	officeMapStartDeviceOptional: "جهاز البداية (اختياري)",
	officeMapSwitches: "المبدّلات",
	officeMapTelephone: "هاتف",
	officeMapTelephones: "هواتف",
	officeMapUnknown: "غير معروف",
	officeMapUrl: "الرابط",
	officeMapUserPlacedOnMap: "تم وضع المستخدم على الخريطة",
	officeMapUsers: "المستخدمون",
	officeMapViewContents: "عرض المحتويات",
	officeMapViewFullDetails: "عرض التفاصيل الكاملة",
	offline: "غير متصل",
	offlinePaymentOnly: "الدفع غير متصل بالإنترنت",
	oldProject: "مشروع قديم",
	onSale: "للبيع",
	onSecond: "في الثانية",
	onTime: "في الوقت المحدد",
	onTimeRate: "معدل الالتزام بالوقت",
	oneOf: "واحد من",
	open: "افتح",
	openBoard: "فتح كانبان",
	openDate: "تاريخ الافتتاح",
	openInModal: "فتح في نافذة مودال",
	openInNewTab: "فتح في علامة تبويب جديدة",
	openNavigation: "فتح التنقل",
	openedDate: "تاريخ الفتح",
	optional: "اختياري",
	orClickToSelect: "أو انقر لتحديد الملفات",
	order: "طلب",
	orderNumber: "رقم الطلب",
	orders: "الطلبات",
	ordersCart: "رسم بياني للطلبات",
	otAfterWork: "عمل إضافي بعد الدوام",
	otBeforeWork: "عمل إضافي قبل الدوام",
	otherBenefits: "مزايا أخرى",
	otherDeductions: "خصومات أخرى",
	otherInsurance: "تأمين آخر",
	outOfStock: "نفدت الكمية",
	overdue: "متأخر",
	overtimeComment: "تعليق على العمل الإضافي",
	overtimeDays: "أيام العمل الإضافي",
	overtimeHours: "ساعات العمل الإضافي",
	overtimeRate: "سعر العمل الإضافي",
	overtimeSummary: "ملخص العمل الإضافي",
	overtimeTotal: "إجمالي العمل الإضافي",
	overview: "نظرة عامة",
	owner: "مالك",
	ownership: "الملكية",
	pageNotFound: "الصفحة غير موجودة",
	pageNotFoundDescription:
		"عذراً! الصفحة التي تبحث عنها غير موجودة أو تم نقلها. ربما تمت إزالتها أو تغيير اسمها أو أنها غير متاحة مؤقتاً.",
	pages: "صفحات",
	paid: "مدفوع",
	paidStatus: "حالة الدفع",
	paidTimeOff: "إجازة مدفوعة",
	paidTimeOffDays: "أيام الإجازة المدفوعة",
	parent: "الأب",
	parentCategory: "الفئة الأصلية",
	parentDepartment: "القسم الرئيسي",
	parentTask: "مهمة والدية",
	parentType: "نوع الأصل",
	parentUser: "المستخدم الرئيسي",
	participant: "مشارك",
	passportEndDate: "تاريخ انتهاء جواز السفر",
	passportImages: "صور جواز السفر",
	passportNo: "رقم جواز السفر",
	passportStartDate: "تاريخ إصدار جواز السفر",
	password: "كلمة المرور",
	pause: "إيقاف مؤقت",
	paused: "موقوف مؤقتا",
	payDate: "تاريخ المرتب",
	paymentMethod: "طريقة الدفع",
	paymentMethods: "طرق الدفع",
	paymentSystem: "نظام الدفع",
	payrollBreakdown: "تفاصيل الرواتب",
	payrollCalcError: "فشل حساب الرواتب.",
	payrollCalcHint: "الموظف والفترة مطلوبان. انقر لحساب إجماليات الرواتب وحفظها.",
	payrollCalcMissingFields: "يرجى اختيار الموظف وبداية ونهاية الفترة.",
	payrollCommentsForEmployee: "تعليقات للموظف",
	payrollGeneratedFromAttendance: "كشف الرواتب المُنشأ من الحضور",
	payrollHealthInsurancePremium: "التأمين الصحي (قسط)",
	payrollIndexLabel: "الرقم",
	payrollIndexPlaceholder: "الفهرس",
	payrollInternalNotes: "ملاحظات داخلية",
	payrollNotesSection: "ملاحظات",
	payrollType: "نوع كشف المرتبات",
	payrollUsesHrSettings:
		"العمل الإضافي وأسعار الضرائب والمزايا الافتراضية (غداء، نقل، صحة) تتبع إعدادات الموارد البشرية (النظام → إعدادات الموارد البشرية).",
	pc: "كمبيوتر",
	pcHealth: "صحة الكمبيوتر",
	pcs: "أجهزة الكمبيوتر",
	pdf: "PDF",
	penalties: "غرامات",
	pending: "معلق",
	pensionAmount: "مبلغ التقاعد",
	pensionRate: "معدل التقاعد",
	periodEnd: "نهاية الفترة",
	periodStart: "بداية الفترة",
	permInput_calendarEvent_overlayCustomCalendars: "تقاويم مخصصة (مرشحات)",
	permInput_calendarEvent_overlayIt: "تقاويم تقنية المعلومات (ضمان الجهاز)",
	permInput_calendarEvent_overlayPeople: "تقاويم الأشخاص (الموارد البشرية)",
	permInput_calendarEvent_overlayReminders: "طبقة التذكيرات",
	permInput_calendarEvent_overlayTasks: "المهام (طبقات الأولوية)",
	permInput_calendarEvent_overlayTickets: "طبقة التذاكر (المواعيد النهائية حسب المجال)",
	permInput_chat_attachFile: "إرفاق الملفات",
	permInput_chat_calling: "المكالمات الصوتية",
	permInput_chat_pin: "تثبيت الرسائل",
	permInput_chat_searchFiles: "البحث في الملفات",
	permInput_chat_searchMessages: "البحث في الرسائل",
	permInput_chat_sendMessage: "إرسال الرسائل",
	permInput_chat_star: "تمييز الرسائل بنجمة",
	permInput_chat_videoCalling: "مكالمات الفيديو",
	permModuleCrud_download: "تنزيل التقويم (استيراد .ics)",
	permModuleCrud_upload: "رفع التقويم (تصدير .ics)",
	permanentDelete: "حذف نهائي؟",
	permission: "إذن",
	permissions: "الأذونات",
	persons: "الأشخاص",
	phone: "هاتف",
	photo: "صورة",
	photos: "صور",
	pickEmoji: "اختر إيموجي",
	pinnedMessages: "الرسائل المثبتة",
	placed: "وضعت",
	placedState: "حالة الوضع",
	placeholder: "نص العنصر النائب",
	platformDashboard: "لوحة التحكم في المنصة",
	platformSpecificSettings: "إعدادات محددة للمنصة",
	platforms: "المنصات",
	audioPlaybackSpeed: "سرعة التشغيل: {rate}. اضغط للتغيير.",
	playbackMute: "كتم الصوت",
	playbackUnmute: "إلغاء الكتم",
	playbackVoiceMessage: "رسالة صوتية",
	playbackVideoMessage: "رسالة فيديو",
	previewVoiceMessage: "معاينة الرسالة الصوتية",
	play: "تشغيل",
	playStatus: "حالة التشغيل",
	playing: "تشغيل",
	playingComposition: "تشغيل التكوين",
	playingHistory: "تاريخ التشغيل",
	playlist: "قائمة التشغيل",
	playlistStatistics: "إحصائيات قوائم التشغيل",
	playlistsWithAds: "قوائم التشغيل مع الإعلانات",
	playlistsWithoutAds: "قوائم التشغيل بدون إعلانات",
	podcast: "بودكاست",
	podcastStreams: "تدفقات البودكاست",
	podcasts: "البودكاست",
	ports: "منافذ",
	position: "منصب",
	positionReviewDate: "تاريخ مراجعة المنصب",
	preDefinedFilters: "مرشحات محددة مسبقًا",
	preview: "معاينة",
	previous: "السابق",
	previousStep: "الخطوة السابقة",
	price: "سعر",
	priceB2b: "السعر المؤسسي",
	priceBasic: "السعر الأساسي",
	priceGroup1: "مجموعة السعر 1",
	priceGroup2: "مجموعة السعر 2",
	priceGroup3: "مجموعة السعر 3",
	priceLists: "قوائم الأسعار",
	printedCount: "عدد المطبوعات",
	printer: "طابعة",
	printers: "طابعات",
	priority: "أولوية",
	priorityDescription: "قواعد التخطيط",
	private: "خاص",
	privateChat: "محادثة خاصة",
	privateChatDescription: "يمكن للمستخدمين المحددين فقط رؤية هذه المحادثة والانضمام إليها",
	problem: "مشكلة",
	problemDescription: "وصف المشكلة",
	problemGroup: "مجموعة المشاكل",
	problemGroupSupervisorsPlaceholder:
		"المستخدمون المسؤولون عن معالجة التذاكر في مجموعة المشكلات هذه",
	problemGroupSupervisorsTab: "المشرفون",
	processTime: "وقت المعالجة",
	processing: "معالجة",
	progress: "التقدم",
	product: "منتج",
	productCare: "رعاية المنتج",
	products: "منتجات",
	productsLinked: "المنتجات المرتبطة",
	project: "مشروع",
	projectChanges: "تغييرات المشروع",
	projectDeadline: "الموعد النهائي للمشروع",
	projectDetails: "تفاصيل المشروع",
	projectEndDate: "تاريخ نهاية المشروع",
	projectID: "معرف المشروع",
	projectPartition: "تقسيم المشروع",
	projectPrice: "سعر المشروع",
	projectPrice2: "سعر المشروع",
	projectStartDate: "تاريخ بدء المشروع",
	projectType: "نوع المشروع",
	projectTypes: "أنواع المشاريع",
	projects: "مشاريع",
	promoCode: "رمز ترويجي",
	promoCodes: "رموز الترويج",
	promoCodesAndCertificates: "رموز الترويج والشهادات",
	promotions: "العروض الترويجية",
	propertyNumber: "رقم الملكية",
	providing: "توفير",
	punchActivity: "نشاط تسجيل الحضور",
	pto: "إجازة مدفوعة",
	partial: "جزئي",
	quantity: "كمية",
	radioDashboard: "لوحة تحكم الراديو",
	radioManagementOverview: "نظرة عامة على إدارة البث الإذاعي",
	radioStatistics: "إحصائيات الراديو",
	raises: "الزيادات",
	ram: "ذاكرة الوصول العشوائي",
	rate: "معدل",
	rating: "تقييم",
	readOnly: "للقراءة فقط",
	readOnlyChatNotice: "هذه المحادثة للقراءة فقط بالنسبة للاعضاء. يمكن للمشرفين فقط كتابة الرسائل.",
	readyToGetStarted: "جاهز للبدء",
	recalculatePayroll: "أعد حساب الرواتب",
	recentClients: "العملاء الأخيرون",
	recentContent: "المحتوى الأخير",
	recentMessages: "الرسائل الأخيرة",
	recentOrders: "الطلبات الأخيرة",
	recentTickets: "التذاكر الأخيرة",
	recentTracks: "المسارات الأخيرة",
	refresh: "تحديث",
	registeredAddress: "العنوان المسجل",
	regularHours: "ساعات عادية",
	regularHoursHrScheduleHint:
		"تعبئة تلقائية من إعدادات الموارد البشرية: أيام العمل في الفترة × ساعات العمل يومياً. قابل للتعديل.",
	regularPlaylists: "قوائم التشغيل العادية",
	relatedList: "القائمة ذات الصلة",
	relatedObjects: "العناصر المرتبطة",
	relatedProducts: "المنتجات ذات الصلة",
	relatedTasks: "مهام مرتبطة",
	relations: "علاقات",
	remainingVacation: "الإجازة المتبقية",
	remote: "عن بُعد",
	remoteWorkDays: "أيام العمل عن بُعد",
	remove: "إزالة",
	removeFromList: "إزالة من القائمة",
	removeItem: "إزالة العنصر",
	removed: "تم الإزالة",
	reopen: "إعادة فتح",
	replaceableProduct: "المنتج المستبدل",
	replaceableProducts: "المنتجات القابلة للتبديل",
	replied: "تم الرد",
	reply: "رد",
	request: "طلب",
	requestedForUser: "مطلوب لـ",
	reset: "إعادة تعيين",
	responseTimeDistribution: "توزيع وقت الاستجابة",
	responsible: "مسؤول",
	responsibleAndUsers: "المسؤولون والمستخدمون",
	restoreSelected: "استرجع الملفات المختارة",
	restored: "استرجع",
	returning: "عائد",
	revenue: "الإيرادات",
	revenueOverview: "نظرة عامة على الإيرادات",
	review: "مراجعة",
	rightNow: "الآن",
	role: "دور",
	rom: "ذاكرة القراءة فقط",
	room: "غرفة",
	routers: "أجهزة التوجيه",
	rpaPrice: "سعر عمل قسم RPA",
	ruleName: "اسم القاعدة",
	salary: "الراتب",
	salaryReviewDate: "تاريخ مراجعة الراتب",
	sale: "بيع",
	salePrice: "سعر البيع",
	salesBreakdownByCategory: "تفصيل المبيعات حسب الفئة",
	salesPerformanceOverTime: "أداء المبيعات مع مرور الوقت",
	sat: "السبت",
	save: "حفظ",
	saveChanges: "حفظ التغييرات",
	saveComment: "حفظ التعليق",
	saved: "تم الحفظ",
	schedulingDisabled: "التخطيط معطل",
	schedulingEnabled: "التخطيط مفعل",
	schedulingRules: "قواعد التخطيط",
	search: "بحث",
	searchByNameOrId: "ابحث بالاسم أو المعرف…",
	searchChat: "البحث عن المحادثة...",
	searchChatGroups: "البحث في مجموعات الدردشة...",
	searchConversations: "بحث عن المحادثات...",
	searchResults: "نتائج البحث",
	searchUsers: "البحث عن المستخدمين...",
	secondary: "ثانوي",
	seconds: "ثوانٍ",
	securityAcknowledge: "إقرار",
	securityActions: "إجراءات",
	securityActiveBadge: "نشط",
	securityActiveSessions: "جلسات نشطة",
	securityActivityStatClicks: "نقرات",
	securityActivityStatKeys: "مفاتيح",
	securityActivityStatMoves: "حركات",
	securityActivityTimeline: "الجدول الزمني للنشاط",
	securityAdminNotes: "ملاحظات المسؤول",
	securityAdminNotesDevice: "ملاحظات داخلية عن الجهاز...",
	securityAgentHeartbeat: "نبض الوكيل",
	securityAlertClipPlural: "مقاطع بسبب تنبيه في هذه الصفحة",
	securityAlertClipSingular: "مقطع بسبب تنبيه في هذه الصفحة",
	securityAlertCount: "تنبيه",
	securityAlertCountPlural: "تنبيهات",
	securityAlertDrawerNoMedia:
		"لا وسائط مرتبطة بعد. يحتاج الوكيل إلى FFmpeg للتسجيل والرفع. في Windows يجب أن يكون في PATH أو FFMPEG_PATH.",
	securityAlertDrawerVideoFailed:
		"أُرسل أمر التقاط فيديو دون رفع لقطات. قد يكون هناك خطأ — راجع سجل الوكيل.",
	securityAlertDrawerVideoPending: "جارٍ تسجيل الفيديو وسيظهر قريباً. الوكيل يلتقط ويرفع الآن.",
	securityAlertRecordings: "تسجيلات التنبيه",
	securityAlertRecordingsOnly: "تسجيلات التنبيه فقط",
	securityAlertSt_acknowledged: "مُقر",
	securityAlertSt_false_positive: "إيجابي كاذب",
	securityAlertSt_open: "مفتوح",
	securityAlertSt_resolved: "تم الحل",
	securityAlertsTitle: "تنبيهات الأمان",
	securityAllDevices: "كل الأجهزة",
	securityAllEventTypes: "كل الأنواع",
	securityAllRules: "كل القواعد",
	securityAllSeverities: "كل مستويات الخطورة",
	securityAllStatuses: "كل الحالات",
	securityAppProcessTracking: "تطبيقات / عمليات",
	securityAppTracking: "تطبيقات",
	securityAppUsageToday: "استخدام التطبيقات اليوم (دقائق)",
	securityAssignedUser: "المستخدم المعيّن",
	securityBadgeAlertText: "تنبيه",
	securityBadgeApp: "تطبيق",
	securityBadgeApps: "تطبيقات",
	securityBadgeCapture: "التقاط",
	securityBadgeFiles: "ملفات",
	securityBadgeOff: "إيقاف",
	securityBadgeScr: "شاشة",
	securityBadgeScreenshot: "لقطة",
	securityBadgeVideo: "فيديو",
	securityBadgeWeb: "ويب",
	securityCapture: "التقاط",
	securityCaptureEnabledMaster: "التقاط مفعّل (رئيسي)",
	securityCaptureEverySeconds: "التقاط كل (ثوانٍ)",
	securityCaptureMasterSwitch: "التقاط مفعّل (المفتاح الرئيسي)",
	securityCaptureModes: "أوضاع الالتقاط",
	securityCaptureOffAlertBody:
		"التقاط معطّل صراحة على الجهاز متجاوزاً السياسة. تُطلق التنبيهات دون لقطات أو فيديو.",
	securityCaptureOffAlertTitle: "تجاوز التقاط: إيقاف",
	securityCaptureRecorded: "تم تسجيل الالتقاط",
	securityCaptureWhenOnDesc: "عند التفعيل يمكن التقاط الشاشة والفيديو؛ الإيقاف يعطّل الاثنين",
	securityChartMinutes: "دقائق",
	securityChartVisits: "زيارات",
	securityClearFilters: "مسح المرشحات",
	securityClickLeft: "ي",
	securityClickMiddle: "و",
	securityClickPlain: "نقرة",
	securityClickRight: "ي",
	securityClipWord: "مقطع",
	securityConnectedDevices: "الأجهزة المتصلة",
	securityCreated: "أُنشئ",
	securityDeleteDevice: "حذف الجهاز",
	securityDeleteDeviceConfirm: "هل أنت متأكد أنك تريد حذف",
	securityDeleteDeviceNote:
		"سيؤدي هذا إلى إزالة سجل جهاز الأمان فقط. لن يتأثر ملف تعريف الكمبيوتر الشخصي في تقنية المعلومات.",
	securityDeleteDeviceTitle: "حذف جهاز الأمان",
	securityDeleteMedia: "حذف",
	securityDeletePolicyConfirm: "حذف هذه السياسة؟",
	securityDevice: "جهاز",
	securityDeviceFallback: "جهاز",
	securityDeviceIdLabel: "معرف الجهاز",
	securityDeviceNotFound: "الجهاز غير موجود",
	securityDeviceSettings: "إعدادات الجهاز",
	securityDeviceSettingsHint: "يتجاوز السياسة النشطة لهذا الجهاز. يُورث من السياسة إن لم يُحدد.",
	securityDevicesBreadcrumb: "الأجهزة",
	securityDevicesTitle: "أجهزة الأمان",
	securityDevicesWithAlerts: "أجهزة مع تنبيهات",
	securityDividerCapture: "التقاط",
	securityDividerNotes: "ملاحظات",
	securityDividerTracking: "التتبع",
	securityDuration: "المدة",
	securityEg15: "مثلاً 15",
	securityEg30: "مثلاً 30",
	securityEg300: "مثلاً 300",
	securityEg5: "مثلاً 5",
	securityEg60: "مثلاً 60",
	securityEnabled: "مفعّل",
	securityEnd: "النهاية",
	securityEventFlushSeconds: "تفريغ الأحداث (ثوانٍ)",
	securityEventsCount: "حدث",
	securityEventsCountPlural: "أحداث",
	securityEvtAppProcess: "تطبيق / عملية",
	securityEvtAppUsage: "استخدام التطبيق",
	securityEvtFileEvent: "حدث ملف",
	securityEvtHeartbeat: "نبض",
	securityEvtInputActivity: "نشاط الإدخال",
	securityEvtKeystroke: "ضغطة مفتاح",
	securityEvtMouseClick: "نقرة فأرة",
	securityEvtSessionEnd: "نهاية الجلسة",
	securityEvtSessionStart: "بداية الجلسة",
	securityEvtSystemBoot: "تشغيل النظام",
	securityEvtSystemShutdown: "إيقاف تشغيل النظام",
	securityEvtUsb: "حدث USB",
	securityEvtUserLogin: "دخول المستخدم",
	securityEvtUserLogout: "خروج المستخدم",
	securityEvtWebVisit: "زيارة ويب",
	securityEvtWorkstationLock: "تم قفل الشاشة",
	securityEvtWorkstationUnlock: "تم إلغاء قفل الشاشة",
	securityFailedLoadOverview: "فشل تحميل نظرة أمان عامة",
	securityFailedSavePolicy: "فشل حفظ السياسة",
	securityFalsePositiveBtn: "إيجابي كاذب",
	securityFileEventTracking: "أحداث الملفات",
	securityFilterByDate: "تصفية حسب التاريخ",
	securityFilterDateRange: "تصفية حسب النطاق الزمني",
	securityFilteredSuffix: "(مُصفّى)",
	securityFps: "إطار/ث",
	securityHostname: "اسم المضيف",
	securityInputActivityCounts: "نشاط الإدخال (عدادات)",
	securityInputKeystrokeClickTracking: "تتبع ضغطات المفاتيح والنقر",
	securityInputModeActivityCountsShort: "النشاط فقط — عدادات",
	securityInputModeActivityOnly: "النشاط فقط (عدادات)",
	securityInputModeDisabled: "معطّل",
	securityInputModeDisabledShort: "معطّل — بدون مقاييس إدخال",
	securityInputModeEventsOnly: "الأحداث فقط",
	securityInputModeEventsStream: "الأحداث فقط — تدفق خام",
	securityInputModeFullDetail: "تفاصيل كاملة (ضغطات + نقرات)",
	securityInputModeFullKeystrokes: "تفاصيل كاملة — ضغطات ومواضع النقر",
	securityInputModeShort: "وضع الإدخال",
	securityInputTrackingMode: "وضع تتبع الإدخال",
	securityInternalNotesPlaceholder: "ملاحظات داخلية...",
	securityKeyCharPrefix: "مفتاح:",
	securityLastSeen: "آخر ظهور",
	securityLatestClip: "آخر مقطع",
	securityLinkedItPc: "جهاز كمبيوتر IT مرتبط:",
	securityLiveLoadingSub: "جاري الاتصال بالوكيل — ستظهر معاينة الشاشة خلال لحظات.",
	securityLiveOfflineHint: "الجهاز غير متصل — العرض المباشر يحتاج وكيلاً متصلاً.",
	securityLivePressStart: "اضغط بدء البث المباشر لفتح التدفق.",
	securityLiveScreenAlt: "شاشة مباشرة",
	securityLiveStatusLive: "مباشر",
	securityLiveStatusStandby: "استعداد",
	securityLiveStreamHint: "البث بنصف الدقة، حتى 10 إطارات/ث. الوكيل v1.4.0+ مع jimp.",
	securityLiveWaitingFrames: "جاري تحميل البث المباشر…",
	securityLoggedInSince: "مسجّل الدخول منذ",
	securityLoggedOutSince: "آخر تسجيل خروج",
	securityMediaPrefix: "وسائط",
	securityMediaTitle: "وسائط الأمان",
	securityMiddleClick: "نقرة وسطى",
	securityModuleErrorTitle: "خطأ في وحدة الأمان",
	securityName: "الاسم",
	securityNearbyScreenshots: "لقطات قريبة",
	securityNever: "أبداً",
	securityNewMediaBadge: "جديد",
	securityNewPolicy: "سياسة جديدة",
	securityNoActivityEvents: "لا أحداث نشاط",
	securityNoAlertRecordingsPage: "لا تسجيلات تنبيه في هذه الصفحة",
	securityNoAlertsForDevice: "لا تنبيهات لهذا الجهاز",
	securityNoAlertsFound: "لا توجد تنبيهات",
	securityNoDevicesFound: "لم يتم العثور على أجهزة",
	securityNoEventsMatchFilter: "لا أحداث تطابق المرشح",
	securityNoOpenAlerts: "لا توجد تنبيهات مفتوحة",
	securityNoPoliciesConfigured: "لا توجد سياسات. أنشئ واحدة لبدء المراقبة.",
	securityNoPreview: "لا معاينة",
	securityNoRiskyDevices: "لا توجد أجهزة عالية الخطورة",
	securityNoScreenshotsFound: "لا توجد لقطات",
	securityNoScreenshotsYet: "لا توجد لقطات بعد",
	securityNoSessionsFound: "لا توجد جلسات",
	securityNoSessionsRecorded: "لا جلسات مسجلة",
	securityNoUserSession: "لا توجد جلسة مستخدم",
	securityNoUserSessionLiveHint:
		"الجهاز مشغّل لكن لم يسجّل أي مستخدم دخوله. العرض المباشر والصور غير متاحَين.",
	securityNoUserSessionTitle: "لم يسجّل أي مستخدم دخوله",
	securityNoVideoSegmentsFound: "لا توجد مقاطع فيديو",
	securityNoVideosYet: "لا توجد مقاطع فيديو بعد",
	securityOS: "نظام التشغيل",
	securityOnlineDevices: "الأجهزة المتصلة",
	securityOpenAlerts: "تنبيهات مفتوحة",
	securityOpenPcRecord: "فتح سجل الكمبيوتر",
	securityOverrideOff: "إيقاف",
	securityOverrideOn: "تشغيل",
	securityOverridePrefix: "تجاوز:",
	securityOverviewTitle: "نظرة أمان عامة",
	securityPageOf: "صفحة",
	securityPolActivityTrackingDivider: "تتبع النشاط",
	securityPolAfterHoursStart: "بداية ما بعد الدوام",
	securityPolAlertClipLength: "طول مقطع فيديو التنبيه (ثوانٍ)",
	securityPolAlertScore: "درجة التنبيه (0–100)",
	securityPolAlertSeverity: "خطورة التنبيه",
	securityPolAlertVideoDivider: "تسجيل فيديو عند التنبيه",
	securityPolAlertVideoInfo:
		"عند تفعيل القاعدة يسجّل الوكيل مقطعاً واحداً بإعدادات أدناه. نفس الطول والجودة لكل القواعد.",
	securityPolAllowedHoursDivider: "ساعات التقاط مسموحة",
	securityPolBadgeAlert: "تنبيه",
	securityPolBlockedApps: "تطبيقات محظورة",
	securityPolBlockedAppsPh: "مثلاً telegram، discord، torrent",
	securityPolBlockedDomains: "نطاقات محظورة",
	securityPolBlockedDomainsPh: "مثلاً torrent-site.com، telegram.org",
	securityPolBreadcrumbPolicies: "السياسات",
	securityPolBulkThreshold: "عتبة أحداث الملفات الجماعية (أحداث/دفعة)",
	securityPolBulkThresholdDesc: "عدد أحداث الملفات التخريبية في دفعة رفع واحدة لتفعيل القاعدة",
	securityPolCollectInputMetrics: "جمع مقاييس نشاط الإدخال",
	securityPolCollectInputMetricsDesc: "عدادات أحداث الفأرة واللوحة فقط (بدون محتوى المفاتيح)",
	securityPolCreateAlert: "إنشاء تنبيه",
	securityPolCreateAlertDesc: "عند تطابق القاعدة يُفتح تنبيه أمان (الفيديو من تبويب الالتقاط)",
	securityPolDescription: "الوصف",
	securityPolEditPolicy: "تعديل السياسة",
	securityPolEnableRule: "تفعيل القاعدة",
	securityPolEventsRetention: "احتفاظ بالأحداث (أيام)",
	securityPolEventsRetentionDesc: "سجلات النشاط الأقدم من ذلك تُزال",
	securityPolExcludedDomains: "النطاقات المستثناة",
	securityPolExcludedDomainsPh: "مثلاً online-banking.com",
	securityPolExcludedProcesses: "أسماء العمليات المستثناة",
	securityPolExcludedProcessesPh: "مثلاً 1Password، Bitwarden",
	securityPolInputActivityCounts: "النشاط فقط — عدادات الفأرة والمفاتيح",
	securityPolInputDisabledNoTrack: "معطّل — لا تتبع الإدخال",
	securityPolInputEventsCount: "الأحداث فقط — عدادات المفاتيح فقط",
	securityPolInputFullDetail: "تفاصيل كاملة — ضغطات ومواضع النقر",
	securityPolInputModeLabel: "وضع تتبع الإدخال",
	securityPolInputTrackingDivider: "تتبع الإدخال",
	securityPolMaskSensitive: "إخفاء النوافذ الحساسة (مديرو كلمات المرور، البنوك)",
	securityPolMaskSensitiveDesc: "عدم التقاط لقطات للتطبيقات/النوافذ المستثناة",
	securityPolMaxFps: "أقصى إطار/ث",
	securityPolMediaRetention: "احتفاظ بالوسائط (أيام)",
	securityPolMediaRetentionDesc: "تُحذف لقطات الشاشة ومقاطع الفيديو الأقدم من ذلك",
	securityPolNewSecurityPolicy: "سياسة أمان جديدة",
	securityPolNotifyUsersDesc:
		"سيحصل المستخدمون المحددون على إشعار داخل التطبيق عند تفعيل أي قاعدة في هذه السياسة.",
	securityPolNotifyUsersLabel: "إشعار المشرفين عند تفعيل السياسة",
	securityPolNotifyUsersPh: "ابحث عن المستخدمين للإشعار…",
	securityPolPolicyName: "اسم السياسة",
	securityPolPolicyNamePh: "مثلاً سياسة فريق التطوير",
	securityPolPriority: "الأولوية",
	securityPolPriorityDesc: "رقم أكبر = يُقيَّم أولاً",
	securityPolRecordVideoOnAlert: "تسجيل فيديو عند تنبيه الأمان",
	securityPolRecordVideoOnAlertDesc: "إذا كان إيقافاً تُنشأ التنبيهات دون فيديو",
	securityPolRuleAfterHoursDesc: "يُفعّل عند اكتشاف نشاط خارج ساعات العمل المحددة.",
	securityPolRuleAfterHoursLabel: "نشاط خارج أوقات العمل",
	securityPolRuleBlockedAppDesc: "يُفعّل عند فتح مستخدم مُراقب لتطبيق من القائمة المحظورة.",
	securityPolRuleBlockedAppLabel: "تطبيق محظور",
	securityPolRuleBlockedDomainDesc: "يُفعّل عند زيارة مستخدم مُراقب لنطاق من القائمة المحظورة.",
	securityPolRuleBlockedDomainLabel: "نطاق محظور",
	securityPolRuleBulkFileDesc:
		"يُفعّل عند حدوث عدد كبير من حذف أو إعادة تسمية أو نقل ملفات في دفعة واحدة.",
	securityPolRuleBulkFileLabel: "عمليات ملفات جماعية",
	securityPolRuleUsbDesc: "يُفعّل عند توصيل تخزين USB بجهاز مُراقب.",
	securityPolRuleUsbLabel: "تم اكتشاف تخزين USB",
	securityPolRulesIntro:
		"تحدد القواعد المخالفة وتسجيل التنبيه. عند «إنشاء تنبيه» يُرفع تنبيه أمان؛ الفيديو يتبع تبويب الالتقاط لجميع القواعد.",
	securityPolSavePolicy: "حفظ السياسة",
	securityPolScope: "النطاق",
	securityPolScopeDepartment: "قسم",
	securityPolScopeDevice: "أجهزة محددة",
	securityPolScopeGlobal: "عام — ينطبق على كل الأجهزة",
	securityPolScopeUser: "مستخدمون محددون",
	securityPolTabCapture: "التقاط",
	securityPolTabPrivacy: "الخصوصية والاستثناءات",
	securityPolTabRetention: "الاحتفاظ",
	securityPolTabRules: "القواعد",
	securityPolTrackApps: "تتبع التطبيقات النشطة",
	securityPolTrackFiles: "تتبع نشاط الملفات",
	securityPolTrackWebsites: "تتبع زيارات المواقع",
	securityPolTrackingMaster: "التتبع مفعّل (المفتاح الرئيسي)",
	securityPolTrackingMasterDesc: "عند الإيقاف يتوقف تتبع التطبيق والويب والملفات والإدخال",
	securityPolVisibleNotice: "إظهار إشعار مرئي بالمراقبة للموظفين",
	securityPolVisibleNoticeDesc: "يعرض شريطاً يُعلم الموظف بأن المراقبة نشطة",
	securityPolWorkDayStart: "بداية يوم العمل (نهاية ما بعد الدوام)",
	securityPolWorkingHours: "ساعات العمل (اختياري)",
	securityPolWorkingHoursDesc:
		"التقاط فقط في هذه النافذة. الصيغة: ساعة:دقيقة-ساعة:دقيقة. فارغ = دائماً.",
	securityPolWorkingHoursPh: "09:00-18:00",
	securityPoliciesCaptureHint:
		"تُظهر الشارات ما هو مفعّل. لتشغيل أو إيقاف لقطات الشاشة أو الفيديو أو التطبيقات أو الويب أو الملفات، افتح السياسة (أيقونة القلم) ← تبويب الالتقاط.",
	securityPoliciesTitle: "سياسات الأمان",
	securityPolicyDefaultBadge: "افتراضي السياسة",
	securityPriority: "الأولوية",
	securityQueued: "في قائمة الانتظار!",
	securityRecentOpenAlerts: "تنبيهات مفتوحة حديثة",
	securityRecentScreenshots: "لقطات شاشة حديثة",
	securityRecordEverySeconds: "تسجيل كل (ثوانٍ)",
	securityRecordVideo30s: "تسجيل فيديو (30 ث)",
	securityRefresh: "تحديث",
	securityResolution: "الدقة",
	securityResolutionNotePlaceholder: "ملاحظة الحل (اختياري)",
	securityResolve: "حل",
	securityRightClick: "نقرة يمنى",
	securityRule: "قاعدة",
	securityRuleCode_AFTER_HOURS: "خارج أوقات العمل",
	securityRuleCode_BLOCKED_APP: "تطبيق محظور",
	securityRuleCode_BLOCKED_DOMAIN: "نطاق محظور",
	securityRuleCode_BULK_FILE_EVENTS: "أحداث ملفات جماعية",
	securityRuleCode_USB_DETECTED: "تم اكتشاف USB",
	securitySaveSettings: "حفظ الإعدادات",
	securitySaved: "تم الحفظ",
	securityScope: "النطاق",
	securityScopeType_department: "قسم",
	securityScopeType_device: "جهاز",
	securityScopeType_global: "عام",
	securityScopeType_user: "مستخدم",
	securityScreenshotAlt: "لقطة شاشة",
	securityScreenshotOptionsBlank: "خيارات لقطات الشاشة (فارغ = افتراضي السياسة)",
	securityScreenshots: "لقطات الشاشة",
	securityScreenshotsCount: "لقطات الشاشة",
	securityScreenshotsLabel: "لقطات الشاشة",
	securityScreenshotsToday: "لقطات شاشة اليوم",
	securitySearch: "بحث",
	securitySearchDevicesPlaceholder: "بحث بالمضيف أو المعرف أو المستخدم...",
	securitySegmentLengthSeconds: "طول المقطع (ثوانٍ)",
	securitySelectedCount: "محدد",
	securitySessionActive: "نشط",
	securitySessionIdle: "خامل",
	securitySessionLocked: "الشاشة مقفلة",
	securitySessionLockedCaptureHint: "الشاشة مقفلة — الصور والعرض المباشر غير متاحَين.",
	securitySessionLockedLiveHint:
		"قفل المستخدم الشاشة. التقاط الصور ومقاطع الفيديو والعرض المباشر معطّلة أثناء قفل الشاشة.",
	securitySessionLockedSince: "مقفل منذ",
	securitySessionLockedTitle: "الشاشة مقفلة",
	securitySessionNotFound: "الجلسة غير موجودة",
	securitySessionTimeline: "الجدول الزمني للجلسة",
	securitySessionWord: "جلسة",
	securitySessionsTitle: "الجلسات",
	securitySettingsDrawerTitle: "الإعدادات",
	securitySettingsOverrideHint: "تتجاوز السياسة لهذا الجهاز فقط. اترك كما هو للوراثة.",
	securitySev_critical: "حرج",
	securitySev_high: "مرتفع",
	securitySev_low: "منخفض",
	securitySev_medium: "متوسط",
	securitySeverity: "الخطورة",
	securityShowAllVideos: "عرض كل الفيديوهات",
	securitySourceEvents: "أحداث المصدر",
	securitySpeedSec: "السرعة (ث):",
	securityStart: "البداية",
	securityStartLive: "بدء البث المباشر",
	securityStatOf: "من",
	securityStatus: "الحالة",
	securityStatus_error: "خطأ",
	securityStatus_offline: "غير متصل",
	securityStatus_online: "متصل",
	securityStatus_pending: "قيد الانتظار",
	securityStatus_unknown: "غير معروف",
	securityStopLive: "إيقاف البث",
	securityTabActivity: "النشاط",
	securityTabAlerts: "تنبيهات",
	securityTabLive: "مباشر",
	securityTabScreenshots: "لقطات",
	securityTabSessions: "جلسات",
	securityTabSettings: "الإعدادات",
	securityTabVideos: "فيديوهات",
	securityTakeScreenshot: "التقاط لقطة شاشة",
	securityTitle: "العنوان",
	securityTooltipAppTrack: "تبديل تتبع التطبيقات",
	securityTooltipCaptureMaster: "تبديل التقاط الشاشة والوسائط (رئيسي)",
	securityTooltipScreenshot: "تبديل لقطات الشاشة",
	securityTooltipTrackingMaster: "مفتاح رئيسي لتتبع التطبيقات والويب والملفات والإدخال",
	securityTooltipWebTrack: "تتبع النطاقات",
	securityTopRiskyDevices: "أجهزة الأكثر خطورة",
	securityTracking: "التتبع",
	securityTrackingEnabledMaster: "التتبع مفعّل (رئيسي)",
	securityTrackingMasterSwitch: "التتبع مفعّل (رئيسي)",
	securityTrackingOffAlertBody: "تتبع النشاط معطّل على الجهاز متجاوزاً السياسة.",
	securityTrackingOffAlertTitle: "تجاوز التتبع: إيقاف",
	securityTrackingWhenOffDesc: "عند الإيقاف يتوقف تتبع التطبيق والويب والملفات والإدخال",
	securityUnassigned: "غير معيّن",
	securityUnknown: "غير معروف",
	securityUnknownDevice: "جهاز غير معروف",
	securityUsePolicyDefault: "افتراضي السياسة",
	securityUser: "المستخدم",
	securityUserLoggedIn: "مسجّل الدخول",
	securityVideoOffAlertBody:
		"تسجيل الفيديو معطّل على الجهاز. لن تُلتقط تسجيلات التنبيه حتى لو كانت السياسة تسمح.",
	securityVideoOffAlertTitle: "تجاوز الفيديو: إيقاف",
	securityVideoOptionsBlank: "خيارات تسجيل الفيديو (فارغ = السياسة)",
	securityVideoPlayAllHint:
		"تشغيل الكل من المقطع المحدد إلى الأقدم؛ عند نهاية الصفحة تُحمّل التالية.",
	securityVideoRecording: "تسجيل فيديو",
	securityVideoSegments: "مقاطع فيديو",
	securityVideoSegmentsCount: "مقاطع فيديو",
	securityViewDetail: "التفاصيل",
	securityWebDomainTracking: "نطاقات الويب",
	securityWebPollSeconds: "استطلاع سجل الويب (ثوانٍ)",
	securityWebTracking: "الويب",
	securityWebsiteVisitsToday: "زيارات المواقع اليوم",
	securityWhen: "متى",
	selectAlbum: "اختر الألبوم",
	selectAll: "اختيار الكل",
	selectArtist: "اختر الفني",
	selectBoard: "اختر لوحة",
	selectCategory: "اختر الفئة",
	selectChatPartner: "اختر شريك الدردشة",
	selectClosedDate: "حدد تاريخ الإغلاق",
	selectDate: "اختر التاريخ",
	selectDays: "اختر الأيام",
	selectDomain: "اختر المجال",
	selectEmployee: "اختر الموظف",
	selectFiles: "حدد الملفات",
	selectGroup: "اختر المجموعة",
	selectOpenedDate: "حدد تاريخ الافتتاح",
	selectParentDepartment: "حدد القسم الرئيسي",
	selectParentUser: "حدد المستخدم الرئيسي",
	selectPeriod: "حدد الفترة",
	selectPlatformToManageAndNavigate: "اختر منصة للتحكم والتنقل",
	selectPlaylist: "اختر قائمة التشغيل",
	selectProduct: "اختر المنتج",
	selectSomething: "اختر شيئًا",
	selectUsers: "اختر المستخدمين",
	selectedSteps: "الخطوات المختارة",
	selectedUsers: "المستخدمون المحددون",
	seleteSelected: "اختيار الملفات المختارة",
	send: "إرسال",
	sent: "تم الإرسال",
	seoDesc: "وصف SEO",
	servicesAndPrices: "الخدمات والأسعار",
	setCostOfBuildingPermit: "تعيين تكلفة تصريح البناء",
	setDayOff: "تعيين يوم عطلة",
	settings: "الإعدادات",
	shiftSchedule: "جدول الوردية",
	showAllSteps: "إظهار جميع الخطوات",
	showHistory: "عرض التاريخ",
	showProjectDetails: "عرض تفاصيل المشروع",
	showTableColumnFilters: "إظهار مرشحات الأعمدة",
	showTimeline: "إظهار الجدول الزمني",
	showing: "يظهر",
	shuffle: "خلط",
	shuffleEnabled: "تفعيل الخلط",
	shuffleOverride: "قواعد التخطيط",
	shuffleOverrideDesc: "قواعد التخطيط",
	shuffleOverrideValue: "قواعد التخطيط",
	sickLeave: "إجازة مرضية",
	sickLeaveDays: "أيام الإجازة المرضية",
	signIn: "تسجيل الدخول",
	signUp: "إنشاء حساب",
	size: "حجم",
	slider: "شريط تمرير",
	small: "صغير",
	smb: "مجلد الخادم",
	socialAmount: "مبلغ الدفع الاجتماعي",
	socialCardImages: "صور بطاقة اجتماعية",
	socialCart: "بطاقة اجتماعية",
	socialNetworkLink: "رابط الشبكة الاجتماعية",
	socialRate: "معدل الدفع الاجتماعي",
	software: "برنامج",
	softwareSkills: "مهارات البرمجيات",
	somethingWentWrong: "حدث خطأ ما",
	somethingWentWrongInCreatingSteps: "حدث خطأ أثناء إنشاء الخطوات! حاول مرة أخرى من فضلك",
	sortBy: "ترتيب",
	source: "مصدر",
	special: "خاص",
	specialItems: "عناصر خاصة",
	speed: "سرعة",
	starred: "مرصوف",
	starredMessages: "الرسائل المميزة بنجمة",
	start: "ابدأ",
	startCall: "بدء المكالمة",
	startDate: "تاريخ البدء",
	startDateShort: "تاريخ البدء",
	startRecording: "ابدأ التسجيل",
	startTime: "وقت البدء",
	startVideoCall: "بدء مكالمة فيديو",
	starts: "يبدأ",
	state: "ولاية",
	states: "الولايات",
	status: "الحالة",
	visibility: "الظهور",
	statusUpdate: "تحديث الحالة",
	stayAnonymous: "ابق مجهول الهوية",
	step: "خطوة",
	stepIsNotStartedYet: "الخطوة لم تبدأ بعد",
	stepStatus: "حالة الخطوة",
	stepStatusChangedByUser: "تم تغيير حالة الخطوة بواسطة المستخدم",
	steps: "خطوات",
	stepsLeft: "الخطوات المتبقية",
	stillInOffice: "ما زال في المكتب",
	stockAndProductOverview: "نظرة عامة على المخزون والمنتجات",
	stop: "توقف",
	stopRecording: "توقف عن التسجيل",
	stopped: "توقف",
	streamDJ: "DJ الراديو",
	streamStatistics: "إحصائيات التدفقات",
	streaming: "بث مباشر",
	streamsWithShuffle: "التدفقات مع تفعيل الخلط",
	street: "شارع",
	subDesc: "وصف فرعي",
	submit: "إرسال",
	submittedProjects: "المشاريع المقدمة",
	subscription: "اشتراك",
	subscriptions: "الاشتراكات",
	substation: "محطة فرعية",
	substationNumber: "رقم المحطة الفرعية",
	subtasks: "مهام فرعية",
	subtasksPlaceholder: "أدخل كل مهمة فرعية في خط جديد",
	subtitle: "العنوان الفرعي",
	success: "نجاح",
	suffix: "سونيك",
	sun: "الأحد",
	support: "دعم",
	supportText: "لجميع الأسئلة اكتب",
	switch: "مفتاح",
	switchers: "مبدلات",
	switches: "طابعات",
	syncedFromGoogleContacts: "تمت المزامنة من جهات اتصال Google",
	systemSettings: "إعدادات النظام",
	table: "جدول",
	tag: "وسم",
	tags: "توصيفات",
	takeMeHome: "خذني إلى الصفحة الرئيسية",
	taskCreatedSuccessfully: "تم إنشاء المهمة بنجاح",
	taskCreatedSuccessfullyDescription: "تم إنشاء المهمة بنجاح",
	taskDescription: "وصف المهمة",
	taskMoved: "تم تحريك المهمة",
	taskMovedDescription: "تم تحريك المهمة إلى فئة جديدة",
	taskStatusDistribution: "توزيع حالة المهمة",
	taskTitle: "عنوان المهمة",
	tasksAssigned: "المهام المعينة",
	taxCode: "رمز الضريبة",
	taxNote: "التسمية",
	taxes: "الضرائب",
	technicalFilesUrl: "رابط الملفات التقنية",
	telegram: "تلغرام",
	text: "نص",
	theConstructionDepPrice: "سعر قسم البناء",
	theNumberOfAct: "عدد الأفعال",
	thePriceOfProject: "سعر المشروع",
	themePickerLabel: "موضوع",
	thereIsNoResponsible: "لا يوجد مسؤول",
	thisMonth: "هذا الشهر",
	thu: "الخميس",
	ticket: "تذكرة",
	ticketClosed: "تم إغلاق التذكرة",
	ticketCreateSaveDisabledHint:
		"اختر المجال ومجموعة المشكلة (إن وُجدت) والمشكلة، ثم املأ الحقول المرتبطة المطلوبة قبل الحفظ.",
	ticketDashboard: "لوحة تحكم التذاكر",
	ticketDomain: "المجال",
	ticketHierarchyAddProblem: "إضافة مشكلة",
	ticketHierarchyAddProblemGroup: "إضافة مجموعة مشاكل",
	ticketHierarchyAddRelatedList: "إضافة قائمة مرتبطة",
	ticketHierarchyAddTicket: "إضافة تذكرة",
	ticketHierarchyAddTicketDomain: "إضافة مجال",
	ticketHierarchyAddTicketHint: "يفتح إنشاء تذكرة جديدة مع هذا المجال المحدد.",
	ticketHierarchyGroupsInDomain: "مجموعات المشاكل في هذا المجال",
	ticketHierarchyNoneYet: "لا شيء بعد — استخدم الزر أعلاه.",
	ticketHierarchyProblemsInGroup: "المشاكل في هذه المجموعة",
	ticketHierarchyProblemsLinkedToList: "المشاكل التي تستخدم هذه القائمة",
	ticketSystemOverview: "نظرة عامة على أداء ومقاييس نظام التذاكر",
	ticketTitle: "العنوان",
	ticketType: "النوع",
	ticketTypeDomainsHint:
		"اتركه فارغًا ليكون النوع متاحًا في كل المجالات. اختر مجالًا واحدًا أو أكثر لعرضه فقط هناك.",
	ticketTypeDomainsListAll: "كل المجالات",
	ticketStatus_sent: "مُرسل",
	ticketStatus_in_process: "قيد المعالجة",
	ticketStatus_resolved_rejected: "مرفوض",
	ticketStatus_resolved_approved: "موافق عليه",
	ticketStatus_moved_next: "نُقل إلى التالي",
	ticketStatus_moved_prev: "أُعيد إلى السابق",
	ticketStatus_closed: "مُغلق",
	ticketStatus_not_accepted: "غير مقبول",
	ticketAction_start: "بدء المعالجة",
	ticketAction_next: "الخطوة التالية",
	ticketAction_prev: "الخطوة السابقة",
	ticketAction_approve: "موافقة",
	ticketAction_reject: "رفض",
	ticketAction_close: "إغلاق التذكرة",
	ticketAction_cancel: "إلغاء التذكرة",
	ticketAction_comment: "تعليق",
	cancelTicket: "إلغاء التذكرة",
	ticketCancelReason: "سبب الإلغاء",
	ticketCancelComment: "تعليق إضافي",
	ticketCancelCommentPlaceholder: "أضف تفاصيل لمقدم التذكرة إذا لزم الأمر",
	ticketCancelWarning:
		"سيتم وضع علامة على هذه التذكرة بأنها غير مقبولة وإغلاقها. إذا كان المستخدم ما زال يحتاج إلى مساعدة، فعليه فتح تذكرة جديدة.",
	ticketNotAccepted: "لم يتم قبول التذكرة",
	ticketStepStatus_pending: "قيد الانتظار",
	ticketStepStatus_active: "نشط",
	ticketStepStatus_completed: "مكتمل",
	ticketStepStatus_approved: "موافق عليه",
	ticketStepStatus_rejected: "مرفوض",
	ticketStepStatus_closed: "مُغلق",
	ticketStepStatus_cancelled: "ملغاة",
	tickets: "التذاكر",
	ticketsByDepartment: "التذاكر حسب القسم",
	ticketsByImportance: "التذاكر حسب الأولوية",
	ticketsByProblem: "التذاكر حسب نوع المشكلة",
	ticketsByStatus: "التذاكر حسب الحالة",
	ticketsOverTime: "التذاكر بمرور الوقت",
	timAgreement: "اتفاق TIM",
	timDelays: "تأخيرات TIM",
	timSentProjects: "المشاريع المرسلة إلى TIM",
	time: "وقت",
	timeBasedScheduling: "التخطيط الزمني",
	timeOff: "إجازة",
	timeRange: "النطاق الزمني",
	timeToClose: "وقت إغلاق التذكرة",
	timeToFirstResponse: "وقت أول استجابة",
	timeline: "الجدول الزمني",
	timestamp: "الطابع الزمني",
	timezone: "منطقة الوقت",
	title: "عنوان",
	to: "إلى",
	toChat: "إلى الدردشة",
	toDo: "للقيام",
	today: "اليوم",
	todaysSales: "مبيعات اليوم",
	todo: "المهام",
	todoBoard: "لوحة",
	todoBoards: "لوحات",
	todoCategories: "فئات",
	todoCategory: "فئة",
	todoLabel: "العلامة",
	todoLabels: "العلامات",
	todoTag: "العلامة",
	todoTags: "العلامات",
	todoTask: "مهمة",
	todoTasks: "المهام",
	toggles: "تبديلات",
	top: "أفضل",
	topCustomers: "أفضل العملاء",
	topProducts: "أفضل المنتجات",
	total: "المجموع",
	totalActiveTasks: "إجمالي المهام النشطة",
	totalArtists: "إجمالي الفنانين",
	totalChats: "إجمالي الدردشات",
	totalClients: "إجمالي العملاء",
	totalCoins: "إجمالي العملات",
	totalContent: "إجمالي المحتوى",
	totalCustomers: "إجمالي العملاء",
	totalDeductions: "إجمالي الخصومات",
	totalDuration: "المدة الإجمالية",
	totalGroups: "إجمالي المجموعات",
	totalHours: "إجمالي الساعات",
	missingDays: "الأيام الناقصة",
	missingHours: "الساعات الناقصة",
	scheduled: "المجدول",
	totalHoursWorked: "إجمالي ساعات العمل",
	totalInTrash: "إجمالي في سلة المهملات",
	totalMessages: "إجمالي الرسائل",
	totalOrders: "إجمالي الطلبات",
	totalOvertime: "إجمالي العمل الإضافي",
	totalPlaylists: "إجمالي قوائم التشغيل",
	totalPrice: "السعر الإجمالي",
	totalProducts: "إجمالي المنتجات",
	totalRevenue: "إجمالي الإيرادات",
	totalTickets: "إجمالي التذاكر",
	totalTracks: "إجمالي المسارات",
	totalUses: "إجمالي الاستخدامات",
	totalValue: "القيمة الإجمالية",
	track: "المسار",
	trackPlaylist: "قائمة تشغيل المسار",
	tracks: "المسارات",
	tracksByArtist: "المسارات حسب الفنان",
	transportAllowance: "بدل النقل",
	trash: "سلة المهملات",
	trashAutoDeleteWarning: "تحذير حذف المهملات التلقائي",
	trashEmptied: "سلة المهملات مسحوق",
	trashedOn: "حُذِف في",
	tryAgain: "حاول مرة أخرى",
	tue: "الثلاثاء",
	type: "نوع",
	uncoveredInterval: "فترة غير مشمولة",
	undefined: "غير معرف",
	undo: "تراجع",
	university: "جامعة",
	universityDegree: "درجة جامعية",
	universityDepartment: "قسم الجامعة",
	unjustifiedAbsence: "غياب غير مبرر",
	unknown: "غير معروف",
	unknownArtist: "فنان غير معروف",
	unnamed: "بدون اسم",
	unnamedClient: "عميل بدون اسم",
	unnamedTrack: "مسار بدون اسم",
	unpaid: "غير مدفوع",
	unreadMessages: "الرسائل غير المقروءة",
	unresolvedMissingIntervals: "فترات مفقودة غير محلولة — قد تكون كشوف المرتبات غير دقيقة",
	upcomingBirthdays: "أعياد الميلاد القادمة",
	update: "تحديث",
	updatedAt: "تم التحديث في",
	updates: "تحديثات",
	upload: "رفع",
	uploadDate: "تاريخ الرفع",
	uploading: "تحميل",
	uploads: "تحميلات",
	uptime: "مدة التشغيل",
	urgent: "مهم",
	used: "مستخدم",
	usedCount: "عدد الاستخدامات",
	usedVacation: "الإجازة المستخدمة",
	user: "مستخدم",
	userArchive: "أرشيف المستخدم",
	userDashboard: "لوحة التحكم للمستخدم",
	userDeleted: "تم الحذف",
	userEntered: "دخل المستخدم",
	userProfile: "ملف المستخدم",
	userPayrollCalcUsesAttendance:
		"يستخدم هذا الحساب ملخص الحضور والإجازات المعتمد لـ {monthKey}، ثم يطبّق قواعد الضرائب النشطة من إعدادات الموارد البشرية.",
	userUpdated: "تم التحديث",
	userVisited: "قام المستخدم بزيارة",
	username: "اسم المستخدم",
	users: "الموارد البشرية",
	vacationBalance: "رصيد الإجازة",
	vacationDaysForPeriod: "أيام الإجازة للفترة المحددة",
	vacationInterval: "فترة الإجازة",
	vacationPay: "بدل الإجازة",
	value: "قيمة",
	version: "الإصدار",
	viber: "فايبر",
	video: "فيديو",
	view: "عرض",
	viewAll: "عرض الكل",
	viewDetails: "عرض التفاصيل",
	viewMore: "عرض المزيد",
	viewProject: "عرض المشروع",
	viewSteps: "عرض الخطوات",
	viewTrash: "عرض سلة المهملات",
	village: "قرية",
	villages: "قائمة القرى",
	visitation: "زيارة",
	visitationDeadline: "الموعد النهائي للزيارة",
	visitationDelays: "تأخيرات الزيارة",
	voltage: "جهد",
	voltageLevel: "مستوى الجهد",
	volumes: "أحجام",
	voluntaryPensionAmount: "مبلغ التقاعد التطوعي",
	voluntaryPensionRate: "معدل التقاعد التطوعي (٪)",
	vsPreviousPeriod: "مقارنة بالفترة السابقة",
	warning: "تحذير",
	warrantyDesc: "وصف الضمان",
	warrantyEnd: "نهاية الضمان",
	warrantyProvider: "مورد الضمان",
	warrantyStart: "بداية الضمان",
	watchers: "مشاهد",
	weatherAriaYerevanForecast: "توقعات طقس يريفان",
	weatherCityYerevan: "يريفان",
	weatherClear: "صافٍ",
	weatherCloudy: "غائم",
	weatherDrizzle: "رذاذ",
	weatherFog: "ضباب",
	weatherForecastUnavailable: "التوقعات غير متاحة",
	weatherHeadingYerevan: "طقس يريفان",
	weatherHumidity: "الرطوبة",
	weatherLoadingShort: "الطقس",
	weatherNextHours: "الساعات القادمة",
	weatherPartlyCloudy: "غائم جزئياً",
	weatherRain: "مطر",
	weatherSnow: "ثلج",
	weatherThunderstorm: "عاصفة رعدية",
	weatherUnknown: "التوقعات",
	weatherWind: "الرياح",
	weatherWindUnit: "كم/س",
	wed: "الأربعاء",
	weekly: "أسبوعي",
	whatToDo: "ماذا تفعل",
	whatToDoLink: "ماذا تفعل",
	whatsapp: "واتساب",
	withAttachments: "مع المرفقات",
	withCoins: "مع العملات",
	withFavorites: "مع المفضلة",
	workDays: "أيام العمل",
	workInformation: "معلومات العمل",
	workTime: "وقت العمل",
	workedDays: "أيام العمل",
	workedHours: "ساعات العمل الفعلية",
	working: "يعمل",
	workingDays: "أيام العمل",
	workingHoursByDay: "ساعات العمل حسب اليوم",
	workingMinutes: "دقائق العمل",
	workingState: "حالة العمل",
	workingStatus: "حالة العمل",
	write: "اكتب",
	writeUsIfThereAreAnyQuestions: "اكتب لنا إذا كانت لديك أي أسئلة",
	writingContent: "محتوى الكتابة",
	writingNumber: "كتابة الرقم",
	yes: "نعم",
	yesNextStep: "نعم، انتقل إلى الخطوة التالية",
	yesPreviousStep: "نعم، عد إلى الخطوة السابقة",
	youWontBeAbleToRevert: "لن تتمكن من التراجع عن هذا!",
	yourFileHasBeenDeleted: "تم حذف ملفك.",
	yourFileHasBeenNotSaved: "لم يتم حفظ ملفك.",
	yourFileHasBeenSaved: "تم حفظ ملفك.",
	zipCode: "الرمز البريدي",
	zipCodes: "الرموز البريدية",
	vacationIntervalNoDeduction: "لا يتم خصم الإجازة في أيام غير العمل",
	knowledgeDashboardLoadFailed: "فشل تحميل لوحة المعلومات",
	knowledgeArticlesLoadFailed: "فشل تحميل المقالات",
	knowledgeBase: "قاعدة المعرفة",
	knowledgeCreate: "إنشاء",
	knowledgeRunAutoDocs: "تشغيل التوثيق التلقائي",
	knowledgeTotalArticles: "إجمالي المقالات",
	knowledgePublished: "منشور",
	knowledgeDrafts: "مسودات",
	knowledgeAutoGenerated: "منشأ تلقائيا",
	knowledgeLatestUpdatedArticles: "أحدث المقالات المحدثة",
	knowledgeArticles: "المقالات",
	knowledgeNewArticle: "مقال جديد",
	knowledgeFilterArticles: "تصفية المقالات",
	knowledgeCategories: "الفئات",
	knowledgeParentCategory: "الفئة الأصل",
	knowledgeIcon: "أيقونة",
	knowledgeColor: "اللون",
	knowledgeSortOrder: "ترتيب الفرز",
	knowledgeCategorySaved: "تم حفظ الفئة",
	knowledgeCategoryDeleted: "تم حذف الفئة",
	knowledgeSearch: "بحث",
	knowledgeSearchArticles: "البحث في المقالات",
	knowledgePath: "المسار",
	knowledgeAutoGeneratedDocs: "مستندات منشأة تلقائيا",
	knowledgeSingleRoute: "مسار واحد",
	knowledgeNoScreenshots: "بدون لقطات شاشة",
	knowledgeGenerateDocumentation: "إنشاء التوثيق",
	knowledgeImportGeneratedDocs: "استيراد المستندات المنشأة",
	knowledgeDocumentationGenerationStarted: "بدأ إنشاء التوثيق",
	knowledgeImported: "تم الاستيراد",
	knowledgeGeneratedDocsImported: "تم استيراد {count} مستندات منشأة",
	knowledgeStarted: "بدأ",
	knowledgeFinished: "انتهى",
	knowledgeRun: "تشغيل",
	knowledgeOutput: "المخرجات",
	knowledgeStatus_draft: "مسودة",
	knowledgeStatus_published: "منشور",
	knowledgeStatus_archived: "مؤرشف",
	knowledgeVisibility_public: "عام",
	knowledgeVisibility_private: "خاص",
	knowledgeVisibility_company: "الشركة",
	knowledgeRunStatus_idle: "خامل",
	knowledgeRunStatus_running: "قيد التشغيل",
	knowledgeRunStatus_completed: "مكتمل",
	knowledgeRunStatus_failed: "فشل",
	meetings: "الاجتماعات",
	meetingsListSubtitle: "غرف مجدولة مرتبطة بدردشة APIT والتقويم.",
	meetingsCreateMeeting: "إنشاء اجتماع",
	meetingsEditMeeting: "تعديل الاجتماع",
	meetingsCreateSubtitle: "الاجتماع = حدث تقويم + مجموعة دردشة + غرفة فيديو.",
	meetingsMeetingType: "نوع الاجتماع",
	meetingsDate: "التاريخ",
	meetingsStartTime: "وقت البدء",
	meetingsEndTime: "وقت الانتهاء",
	meetingsTimezone: "المنطقة الزمنية",
	meetingsVisibility: "الرؤية",
	meetingsParticipants: "المشاركون",
	meetingsGroupsDepartments: "المجموعات/الأقسام",
	meetingsOptionalGroupIds: "معرفات مجموعات اختيارية",
	meetingsLocation: "الموقع",
	meetingsReminderTime: "وقت التذكير",
	meetingsMinutesShort: "د",
	meetingsAgenda: "جدول الأعمال",
	meetingsAgendaPlaceholder: "البداية\nمراجعة التصميم\nالخطوات التالية",
	meetingsRecordingEnabled: "التسجيل مفعل",
	meetingsAllowJoinBeforeHost: "السماح بالانضمام قبل المضيف",
	meetingsMuteUsersOnEntry: "كتم المستخدمين عند الدخول",
	meetingsAllowScreenSharing: "السماح بمشاركة الشاشة",
	meetingsSaveAsDraft: "حفظ كمسودة",
	meetingsSaveMeeting: "حفظ الاجتماع",
	meetingsCreateAndNotifyUsers: "إنشاء وإشعار المستخدمين",
	meetingsSaved: "تم حفظ الاجتماع",
	meetingsSaveFailed: "تعذر حفظ الاجتماع",
	meetingsJoin: "انضمام",
	meetingsOpenChat: "فتح الدردشة",
	meetingsParticipantsCount: "{count} مشارك",
	meetingsType_video: "فيديو",
	meetingsType_audio: "صوت",
	meetingsType_in_person: "حضوري",
	meetingsType_hybrid: "هجين",
	meetingsVisibility_private: "خاص",
	meetingsVisibility_company: "الشركة",
	meetingsVisibility_department: "القسم",
	meetingsStatus_draft: "مسودة",
	meetingsStatus_scheduled: "مجدول",
	meetingsStatus_live: "مباشر",
	meetingsStatus_ended: "منتهي",
	meetingsStatus_cancelled: "ملغى",
	aiSettingsAction: "الإجراء",
	aiSettingsAllowedModules: "الوحدات المسموح بها",
	aiSettingsApprove: "موافقة",
	aiSettingsApprovalFailed: "فشل الموافقة",
	aiSettingsDisabled: "معطل",
	aiSettingsEnabled: "مفعل",
	aiSettingsEvent: "الحدث",
	aiSettingsLogs: "السجلات",
	aiSettingsLoadFailed: "فشل في تحميل إعدادات الذكاء الاصطناعي",
	aiSettingsNoGateway: "لم يتم تكوين البوابة",
	aiSettingsNoPendingApprovals: "لا توجد موافقات معلقة",
	aiSettingsNoLogs: "لا توجد سجلات",
	aiSettingsNoPermission: "إذن مسؤول الذكاء الاصطناعي مفقود.",
	aiSettingsPendingApprovals: "الموافقات المعلقة",
	aiSettingsReject: "رفض",
	aiSettingsRejectFailed: "فشل الرفض",
	aiSettingsRefresh: "تحديث",
	aiSettingsRequireApproval: "يتطلب موافقة",
	aiSettingsStatus: "الحالة",
	aiSettingsTime: "الوقت",
	aiSettingsTitle: "إعدادات الذكاء الاصطناعي",
	aiSettingsTool: "الأداة",
	aiSettingsUser: "المستخدم",
	aiSettingsUpdateFailed: "فشل تحديث الإعدادات",
	aiSettingsDefaultMode: "الوضع الافتراضي",
	aiSettingsReadOnly: "قراءة فقط",
	aiSettingsApprovalRequired: "الموافقة مطلوبة",
	aiSettingsAdminOnly: "المسؤول فقط",
	financeActiveCurrencies: "{count} عملات نشطة",
	financeAddCurrency: "إضافة عملة",
	financeCurrencyCode: "الكود",
	financeCurrencyCoefficient: "المعامل",
	financeCurrencyDefault: "افتراضي",
	financeCurrencyName: "الاسم",
	financeCurrencySymbol: "الرمز",
	financeCurrencyUse: "استخدم",
	financeLoadFailed: "فشل في تحميل إعدادات المالية",
	financeSaveSettings: "حفظ الإعدادات",
	financeSavedMessage: "تم حفظ إعدادات المالية",
	financeSaveFailed: "فشل حفظ إعدادات المالية",
	financeSelectedDefault: "المختار الافتراضي:",
	financeSettingsSubtitle: "تتحكم العملات هنا في عرض الأموال الافتراضي عبر صفحات المالية والطلبات.",
	financeSettingsTitle: "إعدادات المالية",
	hrAccrualCoeffPreview: "معاينة المعامل",
	hrAccrualCoeffPreviewLine1: "{accrualWorkedHours} ساعات عمل → {accrualVacationHours} ساعات إجازة",
	hrAccrualCoeffPreviewLine2: "ساعات الإجازة المكتسبة لكل ساعة عمل: {hourlyCoefficient}",
	hrAccrualCoeffStoredNote:
		"يقوم الخادم بتخزين هذا الاستحقاق بالدقائق حتى تتمكن الرواتب وأرصدة الإجازات من استخدام قيم الأيام الجزئية بدون تقريب.",
	hrAccrualFixedYearly: "أيام إجازة سنوية ثابتة",
	hrAccrualFixedYearlyDesc:
		"استحقاق عدد محدد من أيام الإجازة طوال السنة باستخدام جدول يومي أو شهري موجود.",
	hrAccrualModelChoice:
		"اختر نموذج استحقاق نشط واحد. الأيام السنوية ومعامل ساعات العمل يستخدمان منطق OR وليس مدمجة.",
	hrAccrualSuffixMin: "دقيقة",
	hrAccrualVacationMinutesEarned: "دقائق الإجازة المكتسبة",
	hrAccrualVacationMinutesEarnedDesc: "عدد دقائق الإجازة المستحقة لكل وحدة زمن عمل.",
	hrAccrualWorkBreak: "فترة الراحة",
	hrAccrualWorkBreakDesc:
		"الدقائق غير المغطاة يومياً يتم تصنيفها كفترات راحة في فترات الغياب عن المكتب.",
	hrAccrualWorkedHoursModel: "ساعات العمل إلى ساعات الإجازة",
	hrAccrualWorkedHoursModelDesc:
		"استحقاق الإجازة من وقت العمل الفعلي باستخدام معامل ساعات عمل قابل للتكوين.",
	hrAccrualWorkedMinutesUnit: "وحدة دقائق العمل",
	hrAccrualWorkedMinutesUnitDesc: "عدد دقائق العمل التي يجب أن تنتج وحدة استحقاق واحدة.",
	hrWeekdayFri: "جمعة",
	hrWeekdayMon: "اثنين",
	hrWeekdaySat: "سبت",
	hrWeekdaySun: "أحد",
	hrWeekdayThu: "خميس",
	hrWeekdayTue: "ثلاثاء",
	hrWeekdayWed: "أربعاء",
	knowledgeSettingsAiEnabled: "الذكاء الاصطناعي مفعل",
	knowledgeSettingsAiModel: "نموذج الذكاء الاصطناعي",
	knowledgeSettingsAiProvider: "مزود الذكاء الاصطناعي",
	knowledgeSettingsEnableAutoDocs: "تفعيل المستندات التلقائية",
	knowledgeSettingsLanguage: "اللغة الافتراضية",
	knowledgeSettingsMaxSizeMb: "الحد الأقصى لحجم المقالة MB",
	knowledgeSettingsRootCategory: "فئة الجذر للمستندات التلقائية",
	knowledgeSettingsSaveSettings: "حفظ الإعدادات",
	knowledgeSettingsSaved: "تم تحديث إعدادات قاعدة المعرفة",
	knowledgeSettingsTitle: "الإعدادات",
	knowledgeSettingsUploadExt: "امتدادات التحميل المسموح بها",
	knowledgeSettingsVisibility: "الرؤية الافتراضية",
	nvrAddFromList: "إضافة كاميرات من القائمة",
	nvrCamerasList: "قائمة الكاميرات",
	nvrChannel: "القناة",
	nvrChannelId: "المعرف",
	nvrChannelName: "الاسم",
	nvrChannelsTitle: "القنوات المسجلة من هذا NVR",
	nvrConnectionDesc:
		"أدخل IP والمنفذ وقالب المسار (فقط /.../{channel}... — كما في VLC، بدون جزء rtsp://). أضف اسم المستخدم وكلمة المرور RTSP (معظم أجهزة NVR تحتاجها). انقر حفظ لتشغيل مسح شبكة تلقائي، أو استخدم إضافة كاميرات من المسارات أدناه لتسجيل القنوات بدون مسح. افتح كاميرا للعرض المباشر؛ على خريطة المكتب، ضع الأجهزة كالمعتاد.",
	nvrConnectionTitle: "NVR — اتصال واحد لجميع القنوات",
	nvrDiscoveryFailed: "فشل الاكتشاف",
	nvrEnterPaths: "أدخل قناة أو مسار واحد على الأقل.",
	nvrFoundChannels: "تم العثور على {n} قناة (قنوات).",
	nvrFullUrl: "عنوان URL كامل (القناة 101 — تلقائياً من الحقول أعلاه)",
	nvrInitError: "تعذر تهيئة NVR. أعد تحميل الصفحة.",
	nvrIp: "IP الخاص بـ NVR",
	nvrIpPasswordRequired:
		"IP الخاص بـ NVR وكلمة مرور محفوظة مطلوبة. اضبط كلمة المرور وحفظها وسنقوم بمسح القنوات في الحفظ التالي.",
	nvrLoadFailed: "فشل تحميل NVR",
	nvrLiveStatus: "الحالة المباشرة",
	nvrManualDesc:
		"عندما يفشل المسح التلقائي (مثل عدم قدرة API على الوصول إلى NVR)، قم بإدراج القنوات هنا. استخدم واحد لكل سطر: أرقام القنوات مثل 101، 201، مسار مثل /Streaming/Channels/102، أو عنوان rtsp:// كامل. يتم دمج المسارات مع قالب مسار RTSP الخاص بك عند إدخال الأرقام فقط. احفظ NVR أولاً إذا غيرت IP أو القالب، ثم أضف صفوفاً واضغط الزر.",
	nvrManualTitle: "إضافة كاميرات من مسارات RTSP (بدون مسح الخادم)",
	nvrNotReady: "NVR غير جاهز. أعد تحميل الصفحة.",
	nvrNotReadyShort: "NVR غير جاهز.",
	nvrNotWorking: "لا يعمل",
	nvrOfficeMap: "خريطة المكتب",
	nvrOffline: "غير متصل",
	nvrOnline: "متصل",
	nvrPasswordChangeNote: "غيّر واحفظ لتحديث كلمة المرور المحفوظة.",
	nvrPasswordLeaveBlank: "اترك فارغاً للاحتفاظ بكلمة المرور الحالية",
	nvrPasswordRequired: "مطلوب لمعظم أجهزة NVR لاكتشاف القنوات والبث.",
	nvrPasswordStoredLeaveBlank: "تم حفظ كلمة المرور؛ اترك فارغاً للاحتفاظ بها، أو اكتب واحد جديداً.",
	nvrRegisterFailed: "فشل تسجيل المسارات",
	nvrRegisteredCameras: "تم تسجيل {n} كاميرا (كاميرات).",
	nvrRtspPassword: "كلمة مرور RTSP",
	nvrRtspPathTemplate: "قالب مسار RTSP",
	nvrRtspPathTemplateHint: "اكتب فقط المسار مع {channel}. لا تدخل سلسلة rtsp:// الكاملة هنا.",
	nvrRtspUsername: "اسم مستخدم RTSP",
	nvrScanChannels: "مسح القنوات مرة أخرى",
	nvrScanHint: "هذا يحفظ حقول الاتصال الحالية، ثم يمسح.",
	nvrWorkingState: "حالة العمل",
	nvrWorking: "يعمل",
	nvrGridEmpty: "لا توجد قنوات مرتبطة بهذا NVR حتى الآن. قم بتشغيل الاكتشاف على صفحة NVR.",
	nvrGridLoadFailed: "فشل تحميل القنوات",
	nvrGridLoading: "جاري تحميل القنوات…",
	nvrGridStreamFailed: "فشل البدء",
	nvrGridStreamStopped: "توقف البث",
	nvrGridTitle: "جميع قنوات NVR",
	securityRecordingActiveDays: "الأيام النشطة",
	securityRecordingDesc:
		"تفعيل التسجيل على جانب الخادم للكاميرات التي تحتوي على التسجيل على الخادم مفعل. يمكن أيضاً لكل كاميرا أن تحتوي على جدولها الخاص أدناه.",
	securityRecordingEndTime: "وقت الانتهاء",
	securityRecordingGlobalEnable: "تفعيل التسجيل عالمياً",
	securityRecordingGlobalEnableDesc:
		"المفتاح الرئيسي — تعطيل هذا يوقف جميع التسجيلات بغض النظر عن إعدادات كل كاميرا.",
	securityRecordingLoadFailed: "فشل تحميل إعدادات الأمان",
	securityRecordingLocalFs: "نظام الملفات المحلي",
	securityRecordingLocalPathNote:
		"يتم تكوين المسار المحلي عبر متغير البيئة SECURITY_RECORDING_LOCAL_PATH على الخادم.",
	securityRecordingNoScheduleNote:
		"بدون جدول زمني — ستسجل الكاميرات 24/7 عند تفعيل التسجيل على الخادم.",
	securityRecordingRetentionDays: "الاحتفاظ (الأيام)",
	securityRecordingRetentionDesc: "سيتم حذف المقاطع الأقدم من هذا تلقائياً.",
	securityRecordingS3: "S3 / تخزين الكائنات المتوافق",
	securityRecordingS3Note:
		"يتم تكوين بيانات اعتماد S3 عبر متغيرات البيئة على الخادم (AWS_ACCESS_KEY_ID و AWS_SECRET_ACCESS_KEY وما إلى ذلك).",
	securityRecordingSaveSettings: "حفظ الإعدادات",
	securityRecordingSaved: "تم حفظ إعدادات الأمان.",
	securityRecordingSaveFailed: "فشل حفظ الإعدادات",
	securityRecordingScheduleDesc:
		"ينطبق هذا الجدول الزمني على جميع الكاميرات مع تفعيل التسجيل على الخادم والتي لا تحتوي على تجاوز جدول زمني لكل كاميرا.",
	securityRecordingScheduleEnable: "تفعيل الجدول الافتراضي (تسجيل فقط خلال ساعات محددة)",
	securityRecordingScheduleNote:
		"سيتم تشغيل التسجيل في الأيام المحددة بين هذه الساعات. خارج هذه النافذة، يتم إيقاف التسجيل تلقائياً.",
	securityRecordingScheduleTitle: "جدول التسجيل الافتراضي",
	securityRecordingSegmentLength: "طول المقطع (دقائق)",
	securityRecordingSegmentLengthDesc:
		"يتحكم هذا في عدد المرات التي يظهر فيها فيديو جديد على كل صفحة كاميرا.",
	securityRecordingStartTime: "وقت البدء",
	securityRecordingStorage: "التخزين",
	securityRecordingStorageBackend: "النهاية الخلفية للتخزين",
	securityRecordingTitle: "تسجيل الكاميرا على الخادم",
	securitySurveillanceCameraMedia: "وسائط الكاميرا",
	securitySurveillanceDashboard: "لوحة المراقبة",
	securitySurveillanceNoCameras: "لم يتم العثور على كاميرات.",
	securitySurveillanceOffline: "غير متصل",
	securitySurveillanceOnline: "متصل",
	teamWorkload: "عبء عمل الفريق",
	workloadTasks: "المهام",
	workloadTickets: "التذاكر",
	workloadSteps: "الخطوات",
	assignedEmployee: "الموظف المعيّن",
	boughtDate: "تاريخ الشراء",
	broken: "معطل",
	depreciation: "الاستهلاك",
	deviceStatus: "حالة الجهاز",
	handoverDocument: "مستند التسليم",
	maintenanceSchedule: "جدول الصيانة",
	qrCode: "رمز QR",
	repair: "إصلاح",
	repairHistory: "سجل الإصلاح",
	replacementDate: "تاريخ الاستبدال",
	retired: "متقاعد",
	returnDocument: "مستند الإرجاع",
	warrantyDate: "تاريخ الضمان",
	noOpenWorkload: "لا يوجد عبء عمل مفتوح",
	attendanceTable: "جدول الحضور",
	filteredFrom: "تمت التصفية من",
	weekend: "عطلة نهاية الأسبوع",
	late: "متأخر",
	lateDeparture: "مغادرة متأخرة",
	employees: "الموظفون",
	exportToExcel: "تصدير إلى Excel",
	overtime: "العمل الإضافي",
	attendanceNextRefresh: "التحديث التالي",
	refreshAttendanceDevices: "تحديث البيانات من أجهزة الحضور",
	attendanceSyncSuccess: "تمت مزامنة أجهزة الحضور",
	attendanceSyncFailed: "فشلت مزامنة أجهزة الحضور",
	// User account security / profile
	contactInformation: "معلومات الاتصال",
	accountSecurity: "أمان الحساب",
	accountStatus: "حالة الحساب",
	accountStatusActive: "نشط",
	accountStatusLocked: "مقفل",
	mustChangePassword: "يجب تغيير كلمة المرور",
	lockedAt: "تاريخ القفل",
	passwordLastChanged: "آخر تغيير لكلمة المرور",
	accountSecurityDesc: "كلمات المرور الحالية لا تظهر أبدًا. استخدم كلمة مرور مؤقتة أو رابط إعادة تعيين آمن عند الحاجة لتغيير بيانات الاعتماد.",
	accountSecurityHint: "استخدم «إعادة تعيين كلمة المرور» عند الحاجة لتدوير فوري لبيانات الاعتماد. استخدم «إرسال رابط إعادة التعيين» عندما يجب أن يختار المستخدم كلمة مرور جديدة دون أن يرى المسؤول أي سر.",
	lockAccount: "قفل الحساب",
	unlockAccount: "فتح الحساب",
	forcePasswordChangeAction: "فرض تغيير كلمة المرور",
	clearForcedPasswordChange: "إلغاء فرض تغيير كلمة المرور",
	resetPassword: "إعادة تعيين كلمة المرور",
	sendResetLink: "إرسال رابط إعادة التعيين",
	sessionVisibilityRequiresPermission: "عرض الجلسات والأجهزة يتطلب إذنًا إضافيًا.",
	resetPasswordConfirmTitle: "إعادة تعيين كلمة المرور هذه؟",
	resetPasswordConfirmText: "سيتم إنشاء كلمة مرور مؤقتة ويجب على المستخدم تغييرها عند تسجيل الدخول التالي.",
	temporaryPasswordGenerated: "تم إنشاء كلمة مرور مؤقتة",
	temporaryPasswordShareHint: "شاركها فقط عبر قناة آمنة.",
	sendResetLinkConfirmTitle: "إرسال رابط إعادة تعيين كلمة المرور؟",
	sendResetLinkConfirmText: "سيتم إرسال رابط إعادة تعيين آمن لمرة واحدة إلى هذا المستخدم عبر البريد.",
	passwordResetLinkSent: "تم إرسال رابط إعادة تعيين كلمة المرور.",
	lockAccountConfirmTitle: "قفل هذا الحساب؟",
	unlockAccountConfirmTitle: "فتح هذا الحساب؟",
	lockAccountConfirmText: "لن يتمكن المستخدم من تسجيل الدخول حتى يتم فتح الحساب.",
	unlockAccountConfirmText: "سيتمكن المستخدم من تسجيل الدخول فورًا مرة أخرى.",
	accountLockedMsg: "تم قفل الحساب.",
	accountUnlockedMsg: "تم فتح الحساب.",
	forcePasswordChangeConfirmTitle: "فرض تغيير كلمة المرور عند تسجيل الدخول التالي؟",
	removeForcedPasswordChangeConfirmTitle: "إزالة فرض تغيير كلمة المرور؟",
	forcePasswordChangeConfirmText: "سيُسمح للمستخدم بتسجيل الدخول فقط لإكمال تغيير كلمة المرور قبل استخدام المنصة.",
	removeForcedPasswordChangeConfirmText: "سيُسمح للمستخدم بمواصلة تسجيل الدخول بشكل طبيعي.",
	forcedPasswordChangeEnabled: "تم تفعيل فرض تغيير كلمة المرور.",
	forcedPasswordChangeRemoved: "تم إزالة فرض تغيير كلمة المرور.",
	securityUpdated: "تم تحديث الأمان",
	securityActionFailed: "فشل إجراء الأمان",
	knownDevicesAndSessions: "الأجهزة المعروفة والجلسات المفتوحة",
	knownDevicesAndSessionsDesc: "المواقع تقريبية وتمثل عادة مصدر IP أو مزود الخدمة أو VPN أو بوابة المكتب وليس الموقع الفعلي الدقيق للجهاز.",
	openSessionsBadge: "{count} مفتوحة",
	revokeOtherSessions: "إلغاء الجلسات الأخرى",
	registeredDevices: "الأجهزة المسجلة",
	unknownDevice: "جهاز غير معروف",
	unknownBrowser: "متصفح غير معروف",
	unknownOs: "نظام تشغيل غير معروف",
	browserOnOs: "{browser} على {os}",
	firstSeen: "أول ظهور",
	sessionsBadge: "{count} جلسات",
	currentDevice: "الجهاز الحالي",
	noKnownDevices: "لا توجد أجهزة معروفة مسجلة بعد.",
	approximateLoginOrigins: "مواقع تسجيل الدخول التقريبية",
	sessionDetails: "تفاصيل الجلسات",
	device: "الجهاز",
	network: "الشبكة",
	lastActive: "آخر نشاط",
	approximateLocationUnavailable: "الموقع التقريبي غير متاح",
	revoke: "إلغاء",
	noAuthSessions: "لا توجد جلسات مصادقة مسجلة بعد.",
	sessionOriginApproximateNote: "بيانات أصل الجلسة تقريبية. لا تعتبر تحديد الموقع الجغرافي لـ IP موقعًا دقيقًا للجهاز.",
	connectedMeansNote: "«متصل» يعني أن المتصفح/التطبيق لا يزال يملك مقبسًا حيًا. «غير متصل» يعني أن المتصفح أُغلق أو أصبح غير متصل، لكن جلسة تسجيل الدخول المحفوظة قد تبقى صالحة حتى تسجيل الخروج أو الإلغاء أو انتهاء الصلاحية.",
	revokeThisSessionTitle: "إلغاء هذه الجلسة؟",
	revokeThisSessionText: "سيُجبر الجهاز/الجلسة المحددة على تسجيل الدخول مجددًا.",
	revokeSession: "إلغاء الجلسة",
	sessionRevoked: "تم إلغاء الجلسة",
	sessionRevokedSuccess: "تم إلغاء الجلسة المحددة بنجاح.",
	failedToRevokeSession: "فشل إلغاء الجلسة",
	unableToRevokeSession: "تعذر إلغاء الجلسة المحددة.",
	revokeOtherSessionsTitle: "إلغاء الجلسات الأخرى؟",
	revokeOtherSessionsText: "سيتم إلغاء جميع جلسات هذا المستخدم باستثناء الجلسة الحالية عندما يلغي المستخدم أجهزته الخاصة.",
	revokeSessions: "إلغاء الجلسات",
	sessionsRevoked: "تم إلغاء الجلسات",
	revokedSessionsCount: "تم إلغاء {count} جلسات.",
	failedToRevokeSessions: "فشل إلغاء الجلسات",
	unableToRevokeSessions: "تعذر إلغاء الجلسات المحددة.",
	failedToLoadSessions: "فشل تحميل الجلسات",
	unableToLoadUserSessions: "تعذر تحميل جلسات المستخدم.",
	sessionStatusRevoked: "ملغاة",
	sessionStatusConnected: "متصل",
	sessionStatusDisconnected: "غير متصل",
	currentSession: "الحالية",
	passwordChangeOnly: "تغيير كلمة المرور فقط",
	faceId: "Face ID",
	passwordsNeverShownHint: "كلمات المرور لا تظهر هنا. استخدم تبويب الأمان لقفل أو فتح هذا الحساب، أو فرض تغيير كلمة المرور، أو إنشاء كلمة مرور مؤقتة، أو إرسال رابط إعادة التعيين.",
	sharedFolders: "المجلدات المشتركة",
	flexId: "Flex Id",
	emailNotProvided: "البريد الإلكتروني غير متوفر",
	anonymousUser: "مستخدم مجهول",
	noMapPointsYet: "لا توجد نقاط على الخريطة بعد",
	noMapPointsYetDesc: "لا تتوفر بعد مواقع جلسات بإحداثيات تقريبية. يمكن للخادم تتبع الأجهزة والجلسات دون مزود جغرافي.",
	googleMapsKeyNotConfigured: "مفتاح Google Maps غير مُعد",
	googleMapsKeyNotConfiguredDesc: "عيّن REACT_APP_GOOGLE_MAPS_API_KEY لعرض خريطة الجلسات التقريبية.",
	mapFailedToLoad: "فشل تحميل الخريطة",
	mapFailedToLoadDesc: "تعذر تحميل Google Maps الآن.",
	approximateLocation: "موقع تقريبي",
	attendanceLastRefreshed: "آخر تحديث",
	quarter: "ربع السنة",
	year: "السنة",
	currentQuarter: "الربع الحالي",
	currentYear: "السنة الحالية",
	chatClearHistory: "مسح السجل",
	chatClearHistoryConfirm: "مسح سجل هذه الدردشة لك فقط؟",
	chatDeleteForMe: "حذف الدردشة",
	chatDeleteForMeConfirm: "حذف هذه الدردشة لك فقط؟ سيتم مسح السجل المرئي لك وستختفي الدردشة من الشريط الجانبي.",
	chatBlockUser: "حظر المستخدم",
	chatUnblockUser: "إلغاء حظر المستخدم",
	chatBlockedSection: "جهات الاتصال المحظورة",
	chatBlockUserConfirm: "حظر هذا المستخدم؟ لن يتمكن من مراسلتك في هذه الدردشة.",
};
